window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = (instance.id === evt.detail.sectionId);

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).off('focusin');

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match !== null) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size == null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match != null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  }
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();


/* ================ GLOBAL ================ */
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $('#PageContainer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }


    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof this.config.onDrawerOpen === 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function() {
    this.nodes.$parent.on('keyup.drawer', $.proxy(function(evt) {
      // close on 'esc' keypress
      if (evt.keyCode === 27) {
        this.close();
        return false;
      } else {
        return true;
      }
    }, this));

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    this.nodes.$page.on('click.drawer', $.proxy(function() {
      this.close();
      return false;
    }, this));
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();


/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.Header = (function() {
  var selectors = {
    body: 'body',
    navigation: '#AccessibleNav',
    siteNavHasDropdown: '.site-nav--has-dropdown',
    siteNavChildLinks: '.site-nav__child-link',
    siteNavActiveDropdown: '.site-nav--active-dropdown',
    siteNavLinkMain: '.site-nav__link--main',
    siteNavChildLink: '.site-nav__link--last'
  };

  var config = {
    activeClass: 'site-nav--active-dropdown',
    childLinkClass: 'site-nav__child-link'
  };

  var cache = {};

  function init() {
    cacheSelectors();

    cache.$parents.on('click.siteNav', function(evt) {
      var $el = $(this);

      if (!$el.hasClass(config.activeClass)) {
        // force stop the click from happening
        evt.preventDefault();
        evt.stopImmediatePropagation();
      }

      showDropdown($el);
    });

    // check when we're leaving a dropdown and close the active dropdown
    $(selectors.siteNavChildLink).on('focusout.siteNav', function() {
      setTimeout(function() {
        if ($(document.activeElement).hasClass(config.childLinkClass) || !cache.$activeDropdown.length) {
          return;
        }

        hideDropdown(cache.$activeDropdown);
      });
    });

    // close dropdowns when on top level nav
    cache.$topLevel.on('focus.siteNav', function() {
      if (cache.$activeDropdown.length) {
        hideDropdown(cache.$activeDropdown);
      }
    });

    cache.$subMenuLinks.on('click.siteNav', function(evt) {
      // Prevent click on body from firing instead of link
      evt.stopImmediatePropagation();
    });
  }

  function cacheSelectors() {
    cache = {
      $nav: $(selectors.navigation),
      $topLevel: $(selectors.siteNavLinkMain),
      $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
      $subMenuLinks: $(selectors.siteNavChildLinks),
      $activeDropdown: $(selectors.siteNavActiveDropdown)
    };
  }

  function showDropdown($el) {
    $el.addClass(config.activeClass);

    // close open dropdowns
    if (cache.$activeDropdown.length) {
      hideDropdown(cache.$activeDropdown);
    }

    cache.$activeDropdown = $el;

    // set expanded on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'true');

    setTimeout(function() {
      $(window).on('keyup.siteNav', function(evt) {
        if (evt.keyCode === 27) {
          hideDropdown($el);
        }
      });

      $(selectors.body).on('click.siteNav', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown($el) {
    // remove aria on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'false');
    $el.removeClass(config.activeClass);

    // reset active dropdown
    cache.$activeDropdown = $(selectors.siteNavActiveDropdown);

    $(selectors.body).off('click.siteNav');
    $(window).off('keyup.siteNav');
  }

  function unload() {
    $(window).off('.siteNav');
    cache.$parents.off('.siteNav');
    cache.$subMenuLinks.off('.siteNav');
    cache.$topLevel.off('.siteNav');
    $(selectors.siteNavChildLink).off('.siteNav');
    $(selectors.body).off('.siteNav');
  }

  return {
    init: init,
    unload: unload
  };
})();

window.theme = window.theme || {};

theme.MobileNav = (function() {
  var classes = {
    mobileNavOpenIcon: 'mobile-nav--open',
    mobileNavCloseIcon: 'mobile-nav--close',
    subNavLink: 'mobile-nav__sublist-link',
    return: 'mobile-nav__return-btn',
    subNavActive: 'is-active',
    subNavClosing: 'is-closing',
    navOpen: 'js-menu--is-open',
    subNavShowing: 'sub-nav--is-open',
    thirdNavShowing: 'third-nav--is-open',
    subNavToggleBtn: 'js-toggle-submenu'
  };
  var cache = {};
  var isTransitioning;
  var $activeSubNav;
  var $activeTrigger;
  var menuLevel = 1;
  // Breakpoints from src/stylesheets/global/variables.scss.liquid
  var mediaQuerySmall = 'screen and (max-width: 749px)';

  function init() {
    cacheSelectors();

    cache.$mobileNavToggle.on('click', toggleMobileNav);
    cache.$subNavToggleBtn.on('click.subNav', toggleSubNav);

    // Close mobile nav when unmatching mobile breakpoint
    enquire.register(mediaQuerySmall, {
      unmatch: function() {
        closeMobileNav();
      }
    });
  }

  function toggleMobileNav() {
    if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  }

  function cacheSelectors() {
    cache = {
      $pageContainer: $('#PageContainer'),
      $siteHeader: $('.site-header'),
      $mobileNavToggle: $('.js-mobile-nav-toggle'),
      $mobileNavContainer: $('.mobile-nav-wrapper'),
      $mobileNav: $('#MobileNav'),
      $subNavToggleBtn: $('.' + classes.subNavToggleBtn)
    };
  }

  function openMobileNav() {
    var translateHeaderHeight = cache.$siteHeader.outerHeight() + cache.$siteHeader.offset().top;

    cache.$mobileNavContainer
      .prepareTransition()
      .addClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translate3d(0, ' + translateHeaderHeight + 'px, 0)'
    });
    cache.$pageContainer.css({
      transform: 'translate3d(0, ' + cache.$mobileNavContainer[0].scrollHeight + 'px, 0)'
    });

    slate.a11y.trapFocus({
      $container: cache.$mobileNav,
      namespace: 'navFocus'
    });

    cache.$mobileNavToggle
      .addClass(classes.mobileNavCloseIcon)
      .removeClass(classes.mobileNavOpenIcon);

    // close on escape
    $(window).on('keyup.mobileNav', function(evt) {
      if (evt.which === 27) {
        closeMobileNav();
      }
    });
  }

  function closeMobileNav() {
    cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translate3d(0, -100%, 0)'
    });
    cache.$pageContainer.removeAttr('style');

    cache.$mobileNavContainer.one('TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle', function() {
      slate.a11y.removeTrapFocus({
        $container: cache.$mobileNav,
        namespace: 'navFocus'
      });
    });

    cache.$mobileNavToggle
      .addClass(classes.mobileNavOpenIcon)
      .removeClass(classes.mobileNavCloseIcon);

    $(window).off('keyup.mobileNav');
  }

  function toggleSubNav(evt) {
    if (isTransitioning) {
      return;
    }

    var $toggleBtn = $(evt.currentTarget);
    var isReturn = $toggleBtn.hasClass(classes.return);
    isTransitioning = true;

    if (isReturn) {
      // Close all subnavs by removing active class on buttons
      $('.' + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]')
        .removeClass(classes.subNavActive);

      if ($activeTrigger && $activeTrigger.length) {
        $activeTrigger.removeClass(classes.subNavActive);
      }
    } else {
      $toggleBtn.addClass(classes.subNavActive);
    }

    $activeTrigger = $toggleBtn;

    goToSubnav($toggleBtn.data('target'));
  }

  function goToSubnav(target) {

    /*eslint-disable shopify/jquery-dollar-sign-reference */

    var $targetMenu = target
      ? $('.mobile-nav__dropdown[data-parent="' + target + '"]')
      : cache.$mobileNav;

    menuLevel = $targetMenu.data('level') ? $targetMenu.data('level') : 1;

    if ($activeSubNav && $activeSubNav.length) {
      $activeSubNav
        .prepareTransition()
        .addClass(classes.subNavClosing);
    }

    $activeSubNav = $targetMenu;

    var $elementToFocus = target
      ? $targetMenu.find('.' + classes.subNavLink + ':first')
      : $activeTrigger;

    /*eslint-enable shopify/jquery-dollar-sign-reference */

    var translateMenuHeight = $targetMenu[0].scrollHeight;
    if (!target) {
      translateMenuHeight = $targetMenu.outerHeight();
    }

    var openNavClass = menuLevel > 2
      ? classes.thirdNavShowing
      : classes.subNavShowing;

    cache.$mobileNavContainer
      .css('height', translateMenuHeight)
      .removeClass(classes.thirdNavShowing)
      .addClass(openNavClass);

    if (!target) {
      // Show top level nav
      cache.$mobileNavContainer
        .removeClass(classes.thirdNavShowing)
        .removeClass(classes.subNavShowing);
    }

    // Focusing an item in the subnav early forces element into view and breaks the animation.
    cache.$mobileNavContainer.one('TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle', function() {
      slate.a11y.trapFocus({
        $container: $targetMenu,
        $elementToFocus: $elementToFocus,
        namespace: 'subNavFocus'
      });

      cache.$mobileNavContainer.off('.subnavToggle');
      isTransitioning = false;
    });

    // Match height of subnav
    cache.$pageContainer.css({
      transform: 'translate3d(0, ' + translateMenuHeight + 'px, 0)'
    });

    $activeSubNav.removeClass(classes.subNavClosing);
  }

  return {
    init: init,
    closeMobileNav: closeMobileNav
  };
})(jQuery);

window.theme = window.theme || {};

theme.Search = (function() {
  var selectors = {
    search: '.search',
    searchSubmit: '.search__submit',
    searchInput: '.search__input',

    siteHeader: '.site-header',
    siteHeaderSearchToggle: '.site-header__search-toggle',
    siteHeaderSearch: '.site-header__search',

    searchDrawer: '.search-bar',
    searchDrawerInput: '.search-bar__input',

    searchHeader: '.search-header',
    searchHeaderInput: '.search-header__input',
    searchHeaderSubmit: '.search-header__submit',

    mobileNavWrapper: '.mobile-nav-wrapper'
  };

  var classes = {
    focus: 'search--focus',
    mobileNavIsOpen: 'js-menu--is-open'
  };

  function init() {
    if (!$(selectors.siteHeader).length) {
      return;
    }

    initDrawer();
    searchSubmit();

    $(selectors.searchHeaderInput).add(selectors.searchHeaderSubmit).on('focus blur', function() {
      $(selectors.searchHeader).toggleClass(classes.focus);
    });

    $(selectors.siteHeaderSearchToggle).on('click', function() {
      var searchHeight = $(selectors.siteHeader).outerHeight();
      var searchOffset = $(selectors.siteHeader).offset().top - searchHeight;

      $(selectors.searchDrawer).css({
        height: searchHeight + 'px',
        top: searchOffset + 'px'
      });
    });
  }

  function initDrawer() {
    // Add required classes to HTML
    $('#PageContainer').addClass('drawer-page-content');
    $('.js-drawer-open-top').attr('aria-controls', 'SearchDrawer').attr('aria-expanded', 'false');

    theme.SearchDrawer = new theme.Drawers('SearchDrawer', 'top', {
      onDrawerOpen: searchDrawerFocus
    });
  }

  function searchDrawerFocus() {
    searchFocus($(selectors.searchDrawerInput));

    if ($(selectors.mobileNavWrapper).hasClass(classes.mobileNavIsOpen)) {
      theme.MobileNav.closeMobileNav();
    }
  }

  function searchFocus($el) {
    $el.focus();
    // set selection range hack for iOS
    $el[0].setSelectionRange(0, $el[0].value.length);
  }

  function searchSubmit() {
    $(selectors.searchSubmit).on('click', function(evt) {
      var $el = $(evt.target);
      var $input = $el.parents(selectors.search).find(selectors.searchInput);
      if ($input.val().length === 0) {
        evt.preventDefault();
        searchFocus($input);
      }
    });
  }

  return {
    init: init
  };
})();

(function() {
  var selectors = {
    backButton: '.return-link'
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one('click', function(evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();

theme.Slideshow = (function() {
  this.$slideshow = null;
  var classes = {
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    video: 'slideshow__video',
    videoBackground: 'slideshow__video--background',
    closeVideoBtn: 'slideshow__video-control--close',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused'
  };

  function slideshow(el) {
    this.$slideshow = $(el);
    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);

    this.settings = {
      accessibility: true,
      arrows: false,
      dots: false,
      fade: true,
      cssEase: 'linear',
      draggable: true,
      touchThreshold: 20,
      autoplay: false,
      autoplaySpeed: 5000,
      speed: 0,
    };

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11y.bind(this));
    this.$slideshow.slick(this.settings);

    this.$pause.on('click', this.togglePause.bind(this));
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;
    var $prev = $wrapper.find('a.arrow-left');
    var $next = $wrapper.find('a.arrow-right');
    var $first = $wrapper.find('.slideshow__navigation div').eq(0);

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $wrapper.on('focusin', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr('aria-live', 'polite');

      if (autoplay) {
        $slider.slick('slickPause');
      }
    });

    // Resume autoplay
    $wrapper.on('focusout', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.removeAttr('aria-live');

      if (autoplay) {
        // Manual check if the focused element was the video close button
        // to ensure autoplay does not resume when focus goes inside YouTube iframe
        if ($(evt.target).hasClass(classes.closeVideoBtn)) {
          return;
        }

        $slider.slick('slickPlay');
      }
    });

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on('keydown', function(evt) {
        if (evt.which === 37) {
          $slider.slick('slickPrev');
        }

        if (evt.which === 39) {
          $slider.slick('slickNext');
        }

        // Update focus on newly selected tab
        if ((evt.which === 37) || (evt.which === 39)) {
          obj.$dots.find('.slick-active button').focus();
        }
      });
    }

    $prev.on('click', function(evt) {
      $slider.slick('slickPrev');
    });

    $next.on('click', function(evt) {
      $slider.slick('slickNext');
    });

    this.$wrapper.find('.slideshow__navigation div').on('click', function(evt) {
      $slider.slick('slickGoTo', $(this).data('target'));
    });

    $first.addClass('active');
  }

  $('#custom_slide').slick({
    variableWidth: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows:true,
    dots: true,
    prevArrow: '<a href="#" class="arrow-left"><svg class="icon-slide-nav-left" viewBox="-11091 -18027 99.684 42.066"><defs><style>.icon-slide-nav-left {width:99.68px;} .icon-slide-nav-left .cls-1{fill:#ed4c38;}</style></defs><g transform="translate(-11091 -18027)"><path d="M201.484,77.2c-.028.028-.056.028-.085.056a.028.028,0,0,1,.028.028Z" transform="translate(-144.69 -55.559)"/><path class="cls-1" d="M98.826,16.178a16.92,16.92,0,0,1-2.282-2.648.028.028,0,0,1,.028-.028c-.2-.479-.592-.817-1.07-.648a11.845,11.845,0,0,1-4.112.254c-1.634-.028-3.408-.169-4.619,1.408-1.183.479-2.31,1.324-3.634.282-.338-.254-.7.085-1.014.2a4.755,4.755,0,0,1-3.774-.169,7.748,7.748,0,0,0-5.155-.451c-.845.2-1.718.028-2.451.282a3.313,3.313,0,0,1-2.676.113c-.958-.592-1.606.254-2.394.085a.849.849,0,0,1-.479-.225,1.687,1.687,0,0,1-.282-.7c0-.085.253-.282.394-.31.423-.085.873-.141,1.324-.2a.539.539,0,0,0-.479-.479A26.456,26.456,0,0,1,61,11.953a1.72,1.72,0,0,0-1.324.282.888.888,0,0,1-1.042,0,1.563,1.563,0,0,1-.169-.225c-.282-.507-.7-.7-1.1-.282-1.07,1.1-2.028,1.07-3.127.028a1.774,1.774,0,0,0-1.859-.225,1.963,1.963,0,0,1-2.253-.282c-.338-.31-.873-.169-1.324.056-.31.169-.732.394-1.014.31a3.336,3.336,0,0,0-2.451.113c-.789.394-1.69-.282-2.394.31-.7-.479-1.465.282-2.056,0a4.417,4.417,0,0,0-3.774.225,3.177,3.177,0,0,1-1.352.141c-.732-.056-1.549-.732-2.141-.056-.9.958-1.493.028-2.225-.113-.225-.056-.507.2-.732.31a2.529,2.529,0,0,1-1.634.254c-.451-.085-1.155-.113-1.268-.366-.282-.62.423-.9.845-1.239.7-.62,1.408-1.211,2.113-1.859a12.556,12.556,0,0,0,2.76-3.549,2.992,2.992,0,0,0-1.69-4.507c-.648-.225-1.042-.845-1.69-.9-.732-.056-1.493.169-2.225.141a2.591,2.591,0,0,0-1.3.394,37.619,37.619,0,0,0-5.408,2.76.958.958,0,0,1-.761.141c-.423-.254-.62-.225-.845.225-.225.507-.141,1.127-.648,1.521a.541.541,0,0,1-.789-.282c-.282-.563-.732-.789-1.127-.563-.563.31-.761,1.239-1.521,1.07a3.678,3.678,0,0,0-2.394.507c-1.493.563-2.9,1.3-4.366,1.8A4.5,4.5,0,0,0,6.185,9.7c-.62.9-1.8.93-2.563,1.634a1.562,1.562,0,0,0-.169.225C2.073,13.784.693,16.009.777,18.8a14.975,14.975,0,0,1-.451,3.324c-.2.93-.676,1.8.507,2.451.31.169.113.507,0,.761a3.163,3.163,0,0,0-.394,1.042c0,.648.7.423,1.042.676.282.225.62.423.9.648a10.71,10.71,0,0,0,4.366,2.394,6.242,6.242,0,0,1,2.31.986,38.113,38.113,0,0,0,5.155,2.845c3.127,1.465,6.14,3.183,9.211,4.788.648.338,1.437.535,1.38,1.549-.028.225.225.282.423.141.789-.592,1.155-.254,1.352.592.085.366.394.282.62.085.592-.507.986-.31,1.324.31a5.451,5.451,0,0,0,.648.761l-.028.028c.31.254.62.423.93,0,.113-.141.056-.366.141-.535.394-.732.9-1.38,1.268-2.169.451-1.042-.648-1.746-.338-2.676a.976.976,0,0,0-.535-1.155c-1.183-.7-2.394-1.38-3.634-2A19.533,19.533,0,0,1,21.4,30.037a6.289,6.289,0,0,0-2.338-1.493,2.973,2.973,0,0,1-1.972-1.831c-.2-.592-.817-.648-1.239-.958h0c.254-.282-.366-.113-.028-.282a4.848,4.848,0,0,1,2.873-.423,8.143,8.143,0,0,0,1.634.225c2.62-.113,5.155.7,7.774.479,2.084.648,4.253.254,6.366.676a4.657,4.657,0,0,0,2.141-.225c.253-.056.423-.535.62-.845.282.254.535.507.817.732a1.6,1.6,0,0,0,1.324.254,6.4,6.4,0,0,1,2.2.028,33.772,33.772,0,0,0,4.141.394c.338.028,1.014-.113,1.014-.225.028-.648-.563-.507-.958-.592-.732-.113-.423-.676-.479-1.07-.084-.592-.338-.676-.873-.338-1.014.648-1.324.507-1.577-.789a.766.766,0,0,1,0-.254c.479-.225,1.014-.676,1.465-.648,1.1.113,2.2-.028,3.239.085,2.507.282,4.986-.085,7.436,0,.873.028,1.268-.507,1.8-.873A3.287,3.287,0,0,0,54.66,21.5c-.563.028-1.127.085-1.69.085a7.7,7.7,0,0,1-1.38-.169c-.254-.056-.535-.169-.394-.507a.555.555,0,0,1,.423-.282,38.6,38.6,0,0,0,4.422.028c1.718-.225,3.521.7,5.155-.451.2-.141.535-.028.817,0,1.211.028,2.422.113,3.634.085,2.789-.085,5.605.366,8.366-.282,1.437-.338,2.76.282,4.169.366.113,0,.225.169.366.254-.169.085-.31.282-.479.254-1.944-.141-3.887.366-5.859.225-1.465-.085-2.929.423-4.422.338-.254,0-.451.338-.423.648.028.169.113.394.253.451a6.6,6.6,0,0,0,2.451.423c1.634.028,3.3.169,4.929.254a.691.691,0,0,1,.7.676,1.442,1.442,0,0,0,.225.789c.282.366.648.113,1.014.028.254-.056.62-.085.761.056.7.732,1.211.62,1.775-.2a.87.87,0,0,1,1.408-.028,4.337,4.337,0,0,1,.423.986c.141.31.535.338.62.113.366-.986,1.239-.845,2-1.1.732-.225,1.127-.282,1.69.31.423.451.9.2,1.3-.451.141-.225.225-.563.423-.648a1.043,1.043,0,0,1,.817.056c.338.169.563.479.9.648.225.113.62.282.761.169,1.211-.873,2.7-.7,4.028-1.1a8.989,8.989,0,0,0,5.352-4.2A2.081,2.081,0,0,0,98.826,16.178ZM9.537,9.475l-.056-.141h.141ZM29.282,41.5c.028.085.141.169.113.2l-.254.338A.394.394,0,0,1,29.282,41.5ZM23.93,24.009l-.141-.141a.505.505,0,0,1,.2-.141c.085.028.141.028.225.056C24.1,23.868,24.015,23.953,23.93,24.009Zm7.211.986c-.056.028-.169-.028-.254-.028,0-.056-.028-.169,0-.2a.284.284,0,0,1,.254-.085C31.394,24.741,31.423,24.882,31.141,24.995Zm1.887.084c-.084.225-.563.169-.732-.056a.98.98,0,0,1-.225-1.014c.169-.423.592-.451.958-.451.141,0,.282.2.394.282C33.282,24.234,33.2,24.685,33.028,25.079Zm2.986-.592c-.056.451.141,1.014-.535,1.014-.507,0-.761-.479-.9-.93a1.512,1.512,0,0,1,.31-1.324c.085-.141.31-.2.479-.282.169.056.366.085.451.2A1.907,1.907,0,0,1,36.014,24.488Zm2.169-3.155a.285.285,0,0,1-.282-.394.9.9,0,0,1,.254-.423,1.584,1.584,0,0,1,.507-.2,5.042,5.042,0,0,1,2.422.254c.056,0,.085.141.085.2a.348.348,0,0,1-.113.225c-.141.113-.282.282-.451.31C39.816,21.333,39,21.333,38.183,21.333Zm1.1,2.141c-.253.028-.31-.085-.2-.254a.219.219,0,0,1,.225-.056c.056,0,.085.085.141.141C39.394,23.389,39.337,23.474,39.281,23.474Zm.93,2.225c-.056.056-.479-.225-.592-.423-.141-.282-.479-.732-.085-.986a16.076,16.076,0,0,1,2.394-1.239c.366-.169.676.141.873.507h0C42.408,24.8,41.112,25.051,40.211,25.7Zm7.408-4.028a.772.772,0,0,1-.958.338,5.217,5.217,0,0,1-.93-.592c-.141-.113-.282-.31-.253-.451s.253-.254.394-.338a.379.379,0,0,1,.225-.056,4.814,4.814,0,0,1,.873-.085c.394,0,.789.113.9.507C47.928,21.164,47.759,21.474,47.618,21.671Zm.563-8.76c-.056-.056-.2-.113-.2-.169a.453.453,0,0,1,.451-.535.251.251,0,0,1,.225.141C48.773,12.545,48.407,12.939,48.182,12.911Zm5.3,3.521a2.208,2.208,0,0,0-.141.394C53.055,16.488,53.252,16.46,53.477,16.432Zm1.859,2.7a1.356,1.356,0,0,1-1.3.338c-.056-.028-.113-.113-.169-.169a.487.487,0,0,1,.028-.282.981.981,0,0,1,1.408-.366A.428.428,0,0,1,55.336,19.136Zm.31-2.394a.709.709,0,0,1-.845.394c-.2-.028-.225-.225-.056-.366.2-.169.423-.282.62-.423a1.562,1.562,0,0,1,.225.169A.234.234,0,0,1,55.646,16.742Zm1.38-2.451a.814.814,0,0,1-.62.366c-.169-.028-.394-.366-.423-.592s.084-.563.394-.507C56.857,13.643,57.2,14.038,57.026,14.291Zm1.352,5.521a4.329,4.329,0,0,1-.479-.535s.085-.169.169-.169c.338-.085.479.085.563.394C58.547,19.615,58.463,19.7,58.378,19.812Zm3.465-2.2a2.578,2.578,0,0,1-.451-.028c.056-.113.113-.338.169-.338.141,0,.282.113.451.169C61.955,17.5,61.9,17.615,61.843,17.615Zm1.408-1.465a3.047,3.047,0,0,1-.507,0c.056-.31.338-.225.507-.254.056,0,.141.085.225.113C63.392,16.038,63.336,16.15,63.251,16.15ZM73,16.685a1.3,1.3,0,0,1-.789-.084c-.085-.028-.169-.31-.113-.451.113-.338.423-.338.7-.282a4.3,4.3,0,0,1,.7.254C73.335,16.319,73.222,16.6,73,16.685Zm5.774,6.845a.634.634,0,0,1-.141-.141.505.505,0,0,1,.2-.141c.084.028.141.028.225.056C78.968,23.361,78.884,23.446,78.771,23.53Zm3.38-2.845c-.141.028-.31-.085-.479-.141.141-.085.282-.169.451-.282.169.056.31.113.479.169C82.461,20.516,82.32,20.685,82.151,20.685Z" transform="translate(-0.062 -0.368)"/><path d="M236.456,46.5H236.4v.084Z" transform="translate(-169.831 -33.506)"/></g></svg></a>',
    nextArrow:'<a href="#" class="arrow-right"><svg class="icon-slide-nav-right" viewBox="-9322 -18028 83.377 45.158"><defs><style>.icon-slide-nav-right {width:83.38px;height:45.16px;}.icon-slide-nav-right .cls-1 {fill:#ed4c38;}</style></defs><g transform="translate(-9322 -18028)"><path d="M144.913,118.056c-.028,0-.056-.028-.085-.056H144.8Z" transform="translate(-103.999 -84.791)"/><path d="M145.4,120.085c.028-.028.056-.028.085-.056a.028.028,0,0,0-.028-.028Z" transform="translate(-104.43 -86.228)"/><path d="M197.885,121.328c-.028,0-.028-.028-.056-.028H197.8Z" transform="translate(-142.07 -87.162)"/><path d="M4.5,73.7c.028.028.028.056.056.085l.028-.028Z" transform="translate(-3.217 -52.969)"/><path class="cls-1" d="M83.221,26.577c-.254-1.831-.732-3.634-1.042-5.493a6.982,6.982,0,0,1-.2-3.155c.394-1.352.2-1.408-1.07-2.084-.986-.535-1.972-1.042-2.9-1.606a1.116,1.116,0,0,1-.676-1.127c.084-.592-.282-.873-.732-1.042-1.211-.451-2.479-.845-3.69-1.324-.761-.31-1.69-.338-2.225-1.127-1.493-.423-2.648-1.549-4.366-1.606a4.048,4.048,0,0,1-3.774-2.028c-.253-.479-.732-.563-1.127-.761-.761-.366-1.521-.732-2.282-1.07C58.293,3.762,57.589,3.058,56.6,3c-.085.085-.2.169-.282.254.028-.113.028-.254.056-.366-.394-.366-.873-.958-1.38-.817-.817.254-1.352-.2-1.972-.479-.338-.141-.7-.254-1.042-.394-.507-.225-.789,0-1.183.338-.62.507-1.183.169-1.239-.676-.028-.254.169-.507.253-.761l-.056.085c-1.775-.056-1.8-.028-2.113,1.408A6.131,6.131,0,0,1,47.224,3.2a3.633,3.633,0,0,0-.2,1.634A.93.93,0,0,0,47.7,5.9c.366.113.732.2,1.07.31s.451.479.225.62c-.141.113-.338.282-.479.254-.648-.113-1.268-.338-1.887-.479a1.256,1.256,0,0,0-1.324.817A12.72,12.72,0,0,1,44.8,9.536c-.648,1.324-.169,2.253,1.1,2.986a4.2,4.2,0,0,0,1.042.394c3.155,1.155,6.309,2.253,9.436,3.493a22.964,22.964,0,0,1,4.957,2.563.651.651,0,0,1,.282.93.73.73,0,0,1-.93.423c-.986-.254-1.972-.507-2.958-.789a1.478,1.478,0,0,0-1.577.254.839.839,0,0,1-1.239.085,4.14,4.14,0,0,0-3.408-.958,1.369,1.369,0,0,1-.817-.141c-.873-.563-1.775-.282-2.676-.225-.648.056-1.3-.113-1.944-.085-.732.056-1.493-.338-2.169.225-.732.62-.958-.676-1.69-.423-.479.169-1.042-.085-1.549.394-.873.845-1.915.535-2.873.113a4.115,4.115,0,0,1-.93-.62.983.983,0,0,0-1.465.085,4.49,4.49,0,0,1-.592.423,3.093,3.093,0,0,0,1.8,1.493c.479.113.394.338-.282.761-.169.113-.2.028-.225-.028V21c0,.113.169.338.253.338a10.064,10.064,0,0,0,1.324-.113,3.622,3.622,0,0,1-.113-.535c.028-1.1.648-1.493,1.634-1.014.113.056.254.338.2.423a3.361,3.361,0,0,1-1.38,1.352c-.648.592-1.3,1.239-1.972,1.8a1.793,1.793,0,0,1-.986.394q-2.2.127-4.394.169a.348.348,0,0,1-.225-.113c-.056-.028-.085-.085-.141-.113-.535.141-1.1.254-1.634.394-.2-.169-.451-.338-.507-.563a1.947,1.947,0,0,0-2.422-1.352,5.378,5.378,0,0,1-2.225-.085c-.254-.085-.338-.169-.2-.338a.613.613,0,0,1,.225-.141,3.913,3.913,0,0,0,.535-.169,2.246,2.246,0,0,0,.451-.225c-.141-.113-.254-.282-.394-.31a3.02,3.02,0,0,0-1.1-.2c-2.366.282-4.732,1.07-7.126,0a.546.546,0,0,0-.507.085c-1.3.958-2.929.507-4.338.986-.113.225-.225.479-.507.225-.056-.028.085-.282.141-.423.169-.31.535-.676.479-.93-.141-.563-.7-.451-1.127-.366-.563.085-1.1.225-1.634.338a6.343,6.343,0,0,1-3.549.225,1.926,1.926,0,0,0-1.8.535c-.732.592-1.324.282-1.8-.366A2.842,2.842,0,0,0,.1,24.3a18.863,18.863,0,0,0,1.211,2.817c.113.225.535.338.366.62A1.05,1.05,0,0,0,2.1,29.365c.873.563-.535,1.662.507,2.253.056.028-.085.507-.225.732a5.039,5.039,0,0,1-.7.873c-.225.225-.282.479-.028.676a.535.535,0,0,0,.761-.028,1.628,1.628,0,0,1,2-.535c.394.169.366-.225.507-.451.507-.817.535-.817,1.3-.028.113.141.225.394.338.394a17.212,17.212,0,0,1,2.084.479,1.986,1.986,0,0,0,1.549-.535,10.2,10.2,0,0,1,1.155-.761c.789-.479.817-.451,1.577.592a1.079,1.079,0,0,0,.676.366c.31.028.394-.282.451-.535.282-1.07.394-1.127,1.211-.789.254.113.479.31.732.394.62.2,1.1.338,1.69-.31a3.631,3.631,0,0,1,3.127-.873c.9.113,1.831.31,2.732.366.789.056,1.437.141,1.831.986a1.376,1.376,0,0,0,.93.507c1.38.225,2.76.394,4.141.563a1.079,1.079,0,0,0,1.3-.789c.141-.423.535-.592.817-.169.451.676,1.211.845,1.831,1.239.451.31.93.648.958,1.3,0,.366.2.535.507.366s.563-.592.873-.648c1.042-.225.958-.958.986-1.718,0-.394.056-.761.563-.338a3.546,3.546,0,0,0,1.859.507l-.028.085a1.839,1.839,0,0,1,.423-.282c.028-.028.113.028.169.056.141.028.366.028.423.113.141.225,0,.366-.169.479.056.056.085.141.169.169.563.254.9.479.113.9a.494.494,0,0,0-.056.451c.056.141.31.31.394.254.479-.2.958-.423,1.437-.648a3.043,3.043,0,0,0,2.479.676,9.738,9.738,0,0,1,2.7-.2c.451.028.563-.535.254-1.042-.085-.141-.254-.225-.394-.366a2.353,2.353,0,0,1,2.9-.451c.7.31.676.648-.056,1.155a.618.618,0,0,0-.282.394.459.459,0,0,0,.31.366c.845.2,1.606-.056,1.831-.732.169-.507.113-1.268.62-1.437.732-.254.423,1.183,1.268,1.042l-.028.056c.282-.423.592-.761,1.127-.366h.225c.338,0,.761-.085.9.31.141.451-.31.535-.592.7-.085.056-.141.085-.225.141l.028-.056a23.339,23.339,0,0,0-2.535,7.07c-.141.62.338.986,1.014.817.958-.253.958-.253,1.183.394.056.169.084.366.141.535.394,1.127.479,1.183,1.577,1.211a4.128,4.128,0,0,0,2.873-.7,4.274,4.274,0,0,0,1.268-1.07c.507-.592,1.042.2,1.549-.085a5.684,5.684,0,0,0,1.211-.7,5.772,5.772,0,0,1,1.972-1.042A21.2,21.2,0,0,0,70.912,39.7a42.692,42.692,0,0,1,4.169-2.253,28.194,28.194,0,0,0,4-2.366C82.122,33.14,83.756,30.323,83.221,26.577ZM3.593,31.591s-.028-.141,0-.169c.028-.056.113-.085.169-.113C3.819,31.506,3.762,31.591,3.593,31.591Zm.873-.563a6.117,6.117,0,0,1-.676.2.479.479,0,0,1,.366-.563c.141-.028.31.085.451.141C4.579,30.886,4.551,31,4.466,31.027Zm17.1-9.267c.028.423-.7.451-1.127.479-.2,0-.394-.225-.563-.366a2.209,2.209,0,0,1,.676-.254C20.916,21.591,21.507,21.169,21.564,21.76Zm-1.887-.028c.028.028.056.056.056.085-.085-.028-.141-.056-.225-.085C19.564,21.732,19.648,21.7,19.677,21.732Zm-12.731.2c-.028-.338.31-.254.479-.338a2.5,2.5,0,0,1,.592-.169c.31-.056.676-.085,1.014-.169.2-.056.31,0,.423.2.085.141-.2.563-.394.676a2.112,2.112,0,0,1-1.606-.056C7.283,22.014,6.945,21.986,6.945,21.929ZM18.24,27.253a.421.421,0,0,1,.2-.085c.028,0,.113.113.113.113C18.381,27.422,18.268,27.422,18.24,27.253Zm7.605,2.028c-.282.113-.845-.169-.817-.394.028-.141.169-.338.282-.338a1.639,1.639,0,0,1,.732.085C26.183,28.661,26.042,29.2,25.845,29.281Zm.366,2.845c.028.028.056.028.056.056-.085,0-.141-.028-.225-.028C26.1,32.154,26.183,32.1,26.211,32.126Zm.282.169c.394-.056.789-.282,1.1.2A.773.773,0,0,1,26.493,32.295Zm1.239.423c-.056-.056-.056-.113-.085-.2.2-.056.31.028.282.2C27.929,32.717,27.76,32.745,27.732,32.717Zm3.436-.9.056-.141.085.141Zm5.07-5.971c-.817,1.042-.873,1.042-2.169.62-.282.056-.592.225-.817.169-2.141-.789-4.422-.085-6.563-.789a.781.781,0,0,0-.789.113,3.585,3.585,0,0,1-3.239.366,2.95,2.95,0,0,0-2.394.169c-.141.085-.507,0-.507-.056-.141-1.437-1.577-.451-2.141-1.155a.571.571,0,0,0-.507-.085c-.873,1.268-1.8.845-2.789.2-1.465.2-2.958.366-4.422.592a2.969,2.969,0,0,1-1.915-.141.3.3,0,0,1-.113-.169c.028-.085.113-.2.169-.2,2.479-.338,4.957-.761,7.464-.958a40.947,40.947,0,0,1,6.7-.254c1.042.085,2.253.056,2.873-.761.648-.845.789-.592,1.268.028a1.98,1.98,0,0,0,2.253.535.589.589,0,0,0,.169.113,10.126,10.126,0,0,0,3.324.028c1.014,0,1.972.535,3.042.2,1.07-.366,1.746.225,2.141,1.183A1.332,1.332,0,0,1,36.239,25.845Zm8.675-2.929c.028,0,.056.085.085.141a.421.421,0,0,1-.2.085c-.028,0-.056-.085-.085-.141A.6.6,0,0,1,44.914,22.915Zm-.958-2.789c.423-.2.676.056.873.394.028.056-.141.254-.225.394-.085,0-.2.056-.254,0-.225-.113-.451-.254-.676-.394C43.787,20.38,43.844,20.183,43.956,20.127Zm-5.267,4.028a.219.219,0,0,1,.225-.056,2.349,2.349,0,0,1,.338.225c-.113.028-.253.085-.366.113C38.633,24.464,38.548,24.352,38.689,24.155Zm1.1,1.972c-.225.028-.592-.028-.676-.2-.169-.282.141-.423.366-.507a5.355,5.355,0,0,1,.7-.085C40.154,25.676,40.238,26.07,39.788,26.126Zm.394-.845a1.814,1.814,0,0,1-.789-.93,3.078,3.078,0,0,1,.479-.141c.732-.113,1.127.028,1.1.423C40.914,25.084,40.548,25.2,40.182,25.281Zm-.225-1.944a.992.992,0,0,1-.479-.592.981.981,0,0,1,.338-.676.6.6,0,0,1,.507-.113c.282.028.62.113.676-.225.028-.169-.31-.366-.479-.592-.113-.141-.732.085-.366-.394.169-.225.394-.789.845-.507.507.31,1.324.366,1.268,1.268-.028.62.592.9.761,1.437a.939.939,0,0,1-.282.958C41.9,23.2,40.8,23.732,39.957,23.338ZM42.21,25.76c-.056.056-.169.028-.253.028-.028-.056-.113-.141-.085-.169.056-.056.113-.141.2-.141C42.323,25.478,42.379,25.591,42.21,25.76Zm0-1.211c.028-.113.028-.282.113-.338a1.067,1.067,0,0,1,.366-.169c.056.141.084.282.141.423a2.208,2.208,0,0,1-.394.141C42.379,24.633,42.295,24.577,42.21,24.549Zm.873,10.422c0-.056.028-.113.028-.169C43.252,34.858,43.224,34.886,43.083,34.971Zm.169-9.239a5.453,5.453,0,0,1-.31-1.211,1.2,1.2,0,0,1,1.1.563.9.9,0,0,1-.141.732A.382.382,0,0,1,43.252,25.732Zm1.606,8.112a3.235,3.235,0,0,1-.507.028c-.141-.056-.338-.2-.366-.338a.423.423,0,0,1,.423-.507,1.054,1.054,0,0,1,.507.141,1.415,1.415,0,0,1,.338.366C45.139,33.619,45,33.731,44.858,33.844Zm1.352,1.211.056-.141.084.141Zm.141-9.351c-.225.028-.338-.113-.2-.282a.851.851,0,0,1,.451-.141c.028,0,.084.113.141.141A.934.934,0,0,1,46.351,25.7Zm.056-5.155a.593.593,0,0,1,.676-.62,1.878,1.878,0,0,1,1.1.676,5.109,5.109,0,0,1-.676.676A.751.751,0,0,1,46.407,20.549Zm1.155,13.21c.085-.2.254-.2.338.028a1.486,1.486,0,0,1,.085.338c-.113-.056-.254-.085-.366-.141A.234.234,0,0,1,47.562,33.759Zm2.394-13.041c-.169-.028-.31-.056-.479-.085l.169-.338a3.376,3.376,0,0,0,.338.31c.085.056.2.141.282.2A1.27,1.27,0,0,1,49.956,20.718Zm2.648.225c-.31.225-.845-.169-.93-.648-.056-.366.253-.761.563-.732s.592.338.676.817C52.829,20.521,52.773,20.831,52.6,20.944Z" transform="translate(0.056 -0.1)"/><path d="M123.4,66.013c.028-.028.056-.028.085-.056,0-.028-.028-.028-.028-.056Z" transform="translate(-88.626 -47.366)"/><path d="M107.4,83.2l.056.056h.028Z" transform="translate(-77.133 -59.793)"/><path d="M128.3,73.817c.028-.056,0-.028,0,0Z" transform="translate(-92.146 -53.03)"/></g></svg></a>',
    customPaging : function(slider, i) {
        var thumb = $(slider.$slides[i]).data('thumb');
        return '<div class="home-custom-pager"></div>';
    },
    autoplay: true,
    autoplaySpeed: 12000,
  });


  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider;
    var $currentSlide = $slider.find('.' + classes.currentSlide);
    var $nextSlide = $slider.find('.slideshow__slide[data-slick-index="' + nextSlide + '"]');

    this.$wrapper.find('.slideshow__navigation div').eq(currentSlide).removeClass('active');
    this.$wrapper.find('.slideshow__navigation div').eq(nextSlide).addClass('active');

    if (isVideoInSlide($currentSlide)) {
      var $currentVideo = $currentSlide.find('.' + classes.video);
      var currentVideoId = $currentVideo.attr('id');
      theme.SlideshowVideo.pauseVideo(currentVideoId);
      $currentVideo.attr('tabindex', '-1');
    }

    if (isVideoInSlide($nextSlide)) {
      var $video = $nextSlide.find('.' + classes.video);
      var videoId = $video.attr('id');
      var isBackground = $video.hasClass(classes.videoBackground);
      if (isBackground) {
        theme.SlideshowVideo.playVideo(videoId);
      } else {
        $video.attr('tabindex', '0');
      }
    }
  }

  function isVideoInSlide($slide) {
    return $slide.find('.' + classes.video).length;
  }

  slideshow.prototype.togglePause = function() {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused);
      $(slideshowSelector).slick('slickPlay');
    } else {
      this.$pause.addClass(classes.isPaused);
      $(slideshowSelector).slick('slickPause');
    }
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos();
}

theme.SlideshowVideo = (function() {
  var autoplayCheckComplete = false;
  var autoplayAvailable = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      showinfo: 0,
      wmode: 'opaque',
      branding: 0,
      autohide: 0,
      rel: 0
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  };
  var classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    slideshowWrapper: 'slideshow-wrapper',
    slide: 'slideshow__slide',
    slideBackgroundVideo: 'slideshow__slide--background-video',
    slideDots: 'slick-dots',
    videoChrome: 'slideshow__video--chrome',
    videoBackground: 'slideshow__video--background',
    playVideoBtn: 'slideshow__video-control--play',
    closeVideoBtn: 'slideshow__video-control--close',
    currentSlide: 'slick-current',
    slickClone: 'slick-cloned',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay'
  };

  /**
    * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr('id')] = {
      id: $video.attr('id'),
      videoId: $video.data('id'),
      type: $video.data('type'),
      status: $video.data('type') === 'chrome' ? 'closed' : 'background', // closed, open, background
      videoSelector: $video.attr('id'),
      $parentSlide: $video.closest('.' + classes.slide),
      $parentSlideshowWrapper: $video.closest('.' + classes.slideshowWrapper),
      controls: $video.data('type') === 'background' ? 0 : 1,
      slideshow: $video.data('slideshow')
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  function customPlayVideo(playerId) {
    // Do not autoplay just because the slideshow asked you to.
    // If the slideshow asks to play a video, make sure
    // we have done the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (videoPlayers[playerId] && typeof videoPlayers[playerId].pauseVideo === 'function') {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function loadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    var args = $.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);

    initEvents();
  }

  /**
    * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $slide = videos[id].$parentSlide;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
      // Play if autoplay is available or clicked to play
      $slide.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    }

    // Check for autoplay if not already done
    if (!autoplayCheckComplete) {
      autoplayCheckFunction(player, $slide);
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported ? classes.supportsAutoplay : classes.supportsNoAutoplay;
    $(document.documentElement).addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function autoplayCheckFunction(player, $slide) {
    // attempt to play video
    player.playVideo();

    autoplayTest(player)
      .then(function() {
        setAutoplaySupport(true);
      })
      .fail(function() {
        // No autoplay available (or took too long to start playing).
        // Show fallback image. Stop video for safety.
        setAutoplaySupport(false);
        player.stopVideo();
      })
      .always(function() {
        autoplayCheckComplete = true;
        $slide.removeClass(classes.loading);
      });
  }

  function autoplayTest(player) {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function() {
      if (player.getCurrentTime() <= 0) {
        return;
      }

      autoplayAvailable = true;
      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);

    timeout = setTimeout(function() {
      clearInterval(wait);
      deferred.reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds

    return deferred;
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return;
    }

    if ($(window).width() < 750) {
      playOnClick = true;
    } else if (window.mobileCheck()) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality('hd1080');
    var videoData = getVideoOptions(evt);

    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    $('#' + videoData.id).attr('tabindex', '-1');

    sizeBackgroundVideos();

    // Customize based on options from the video ID
    switch (videoData.type) {
      case 'background-chrome':
      case 'background':
        evt.target.mute();
        // Only play the video if it is in the active slide
        if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
          privatePlayVideo(videoData.id);
        }
        break;
    }

    videoData.$parentSlide.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);

    switch (evt.data) {
      case 0: // ended
        setAsFinished(videoData);
        break;
      case 1: // playing
        setAsPlaying(videoData);
        break;
      case 2: // paused
        setAsPaused(videoData);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case 'background':
        videoPlayers[videoData.id].seekTo(0);
        break;
      case 'background-chrome':
        videoPlayers[videoData.id].seekTo(0);
        closeVideo(videoData.id);
        break;
      case 'chrome':
        closeVideo(videoData.id);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    $slide.removeClass(classes.loading);

    // Do not change element visibility if it is a background video
    if (videoData.status === 'background') {
      return;
    }

    $('#' + videoData.id).attr('tabindex', '0');

    switch (videoData.type) {
      case 'chrome':
      case 'background-chrome':
        $slideshow
          .removeClass(classes.paused)
          .addClass(classes.playing);
        $slide
          .removeClass(classes.paused)
          .addClass(classes.playing);
        break;
    }

    // Update focus to the close button so we stay within the slide
    $slide.find('.' + classes.closeVideoBtn).focus();
  }

  function setAsPaused(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    if (videoData.type === 'background-chrome') {
      closeVideo(videoData.id);
      return;
    }

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.status !== 'closed' && videoData.type !== 'background') {
      $slideshow.addClass(classes.paused);
      $slide.addClass(classes.paused);
    }

    if (videoData.type === 'chrome' && videoData.status === 'closed') {
      $slideshow.removeClass(classes.paused);
      $slide.removeClass(classes.paused);
    }

    $slideshow.removeClass(classes.playing);
    $slide.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;
    var classesToRemove = [classes.pause, classes.playing].join(' ');

    $('#' + videoData.id).attr('tabindex', '-1');

    videoData.status = 'closed';

    switch (videoData.type) {
      case 'background-chrome':
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
      case 'chrome':
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
    }

    $slideshow.removeClass(classesToRemove);
    $slide.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
    return videos[evt.target.h.id];
  }

  function startVideoOnClick(playerId) {
    var videoData = videos[playerId];
    // add loading class to slide
    videoData.$parentSlide.addClass(classes.loading);

    videoData.status = 'open';

    switch (videoData.type) {
      case 'background-chrome':
        unsetBackgroundVideo(playerId, videoData);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
      case 'chrome':
        privatePlayVideo(playerId, true);
        break;
    }

    // esc to close video player
    $(document).on('keydown.videoPlayer', function(evt) {
      if (evt.keyCode === 27) {
        closeVideo(playerId);
      }
    });
  }

  function sizeBackgroundVideos() {
    $('.' + classes.videoBackground).each(function(index, el) {
      sizeBackgroundVideo($(el));
    });
  }

  function sizeBackgroundVideo($player) {
    var $slide = $player.closest('.' + classes.slide);
    // Ignore cloned slides
    if ($slide.hasClass(classes.slickClone)) {
      return;
    }
    var slideWidth = $slide.width();
    var playerWidth = $player.width();
    var playerHeight = $player.height();

    // when screen aspect ratio differs from video, video must center and underlay one dimension
    if (slideWidth / videoOptions.ratio < playerHeight) {
      playerWidth = Math.ceil(playerHeight * videoOptions.ratio); // get new player width
      $player.width(playerWidth).height(playerHeight).css({
        left: (slideWidth - playerWidth) / 2,
        top: 0
      }); // player width is greater, offset left; reset top
    } else { // new video width < window width (gap to right)
      playerHeight = Math.ceil(slideWidth / videoOptions.ratio); // get new player height
      $player.width(slideWidth).height(playerHeight).css({
        left: 0,
        top: (playerHeight - playerHeight) / 2
      }); // player height is greater, offset top; reset left
    }

    $player
      .prepareTransition()
      .addClass(classes.loaded);
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background-chrome to a chrome-only player once played
    $('#' + playerId)
      .removeAttr('style')
      .removeClass(classes.videoBackground)
      .addClass(classes.videoChrome);

    videos[playerId].$parentSlideshowWrapper
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].$parentSlide
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].status = 'open';
  }

  function setBackgroundVideo(playerId) {
    // Switch back to background-chrome when closed
    var $player = $('#' + playerId)
      .addClass(classes.videoBackground)
      .removeClass(classes.videoChrome);

    videos[playerId].$parentSlide
      .addClass(classes.slideBackgroundVideo);

    videos[playerId].status = 'background';
    sizeBackgroundVideo($player);
  }

  function initEvents() {
    $(document).on('click.videoPlayer', '.' + classes.playVideoBtn, function(evt) {
      var playerId = $(evt.currentTarget).data('controls');
      startVideoOnClick(playerId);
    });

    $(document).on('click.videoPlayer', '.' + classes.closeVideoBtn, function(evt) {
      var playerId = $(evt.currentTarget).data('controls');
      closeVideo(playerId);
    });

    // Listen to resize to keep a background-size:cover-like layout
    $(window).on('resize.videoPlayer', $.debounce(250, function() {
      if (youtubeLoaded) {
        sizeBackgroundVideos();
      }
    }));
  }

  function removeEvents() {
    $(document).off('.videoPlayer');
    $(window).off('.videoPlayer');
  }

  return {
    init: init,
    loadVideos: loadVideos,
    loadVideo: loadVideo,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents
  };
})();

// On before slide change
$('.hero-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
  $('.animate-in-div').removeClass('active');
  $('.slick-current .animate-in-div').addClass('active');
  $('.animate-out-div').removeClass('active');
  $('.slick-current .animate-out-div').addClass('active');
});


/* ================ TEMPLATES ================ */
(function() {
  var $filterBy = $('#BlogTagFilter');

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on('change', function() {
    location.href = $(this).val();
  });

})();

window.theme = theme || {};

theme.customerTemplates = (function() {

  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
        Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();




/*================ SECTIONS ================*/
window.theme = window.theme || {};

theme.Cart = (function() {
  var selectors = {
    edit: '.js-edit-toggle'
  };
  var config = {
    showClass: 'cart__update--show',
    showEditClass: 'cart__edit--active',
    cartNoCookies: 'cart--no-cookies'
  };

  function Cart(container) {
    this.$container = $(container);
    this.$edit = $(selectors.edit, this.$container);

    if (!this.cookiesEnabled()) {
      this.$container.addClass(config.cartNoCookies);
    }

    this.$edit.on('click', this._onEditClick.bind(this));
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    onUnload: function() {
      this.$edit.off('click', this._onEditClick);
    },

    _onEditClick: function(evt) {
      var $evtTarget = $(evt.target);
      var $updateLine = $('.' + $evtTarget.data('target'));

      $evtTarget.toggleClass(config.showEditClass);
      $updateLine.toggleClass(config.showClass);
    },

    cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled){
        document.cookie = 'testcookie';
        cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
      }
      return cookieEnabled;
    }
  });

  return Cart;
})();

window.theme = window.theme || {};

theme.Filters = (function() {
  var constants = {
    SORT_BY: 'sort_by'
  };
  var selectors = {
    filterSelection: '.filters-toolbar__input--filter',
    sortSelection: '.filters-toolbar__input--sort',
    defaultSort: '.collection-header__default-sort'
  };

  function Filters(container) {
    var $container = this.$container = $(container);

    this.$filterSelect = $(selectors.filterSelection, $container);
    this.$sortSelect = $(selectors.sortSelection, $container);
    this.$selects = $(selectors.filterSelection, $container).add($(selectors.sortSelection, $container));

    this.defaultSort = this._getDefaultSortValue();
    this._resizeSelect(this.$selects);
    this.$selects.removeClass('hidden');

    this.$filterSelect.on('change', this._onFilterChange.bind(this));
    this.$sortSelect.on('change', this._onSortChange.bind(this));
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _onSortChange: function(evt) {
      var sort = this._sortValue();
      if (sort.length) {
        window.location.search = sort;
      } else {
        // clean up our url if the sort value is blank for default
        window.location.href = window.location.href.replace(window.location.search, '');
      }
      this._resizeSelect($(evt.target));
    },

    _onFilterChange: function(evt) {
      window.location.href = this.$filterSelect.val() + window.location.search;
      this._resizeSelect($(evt.target));
    },

    _getSortValue: function() {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function() {
      return $(selectors.defaultSort, this.$container).val();
    },

    _sortValue: function() {
      var sort = this._getSortValue();
      var query = '';

      if (sort !== this.defaultSort) {
        query = constants.SORT_BY + '=' + sort;
      }

      return query;
    },

    _resizeSelect: function($selection) {
      $selection.each(function() {
        var $this = $(this);
        var arrowWidth = 10;
        // create test element
        var text = $this.find('option:selected').text();
        var $test = $('<span>').html(text);

        // add to body, get width, and get out
        $test.appendTo('body');
        var width = $test.width();
        $test.remove();

        // set select width
        $this.width(width + arrowWidth);
      });
    },

    onUnload: function() {
      this.$filterSelect.off('change', this._onFilterChange);
      this.$sortSelect.off('change', this._onSortChange);
    }
  });

  return Filters;
})();

window.theme = window.theme || {};

theme.HeaderSection = (function() {

  function Header() {
    theme.Header.init();
    theme.MobileNav.init();
    theme.Search.init();
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function() {
      theme.Header.unload();
    }
  });

  return Header;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];
  var key = theme.mapKey ? theme.mapKey : '';

  function Map(container) {
    this.$container = $(container);

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript('https://maps.googleapis.com/maps/api/js?key=' + key)
            .then(function() {
              apiStatus = 'loaded';
              initAllMaps();
            });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({address: address}, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$container.find('.map-section__container');

      return geolocate($map)
        .then(function(results) {
          var mapOptions = {
            zoom: config.zoom,
            center: results[0].geometry.location,
            disableDefaultUI: true
          };

          var map = this.map = new google.maps.Map($map[0], mapOptions);
          var center = this.center = map.getCenter();

          //eslint-disable-next-line no-unused-vars
          var marker = new google.maps.Marker({
            map: map,
            position: map.getCenter()
          });

          google.maps.event.addDomListener(window, 'resize', $.debounce(250, function() {
            google.maps.event.trigger(map, 'resize');
            map.setCenter(center);
          }));
        }.bind(this))
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = theme.strings.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = theme.strings.addressQueryLimit;
              break;
            default:
              errorMessage = theme.strings.addressError;
              break;
          }

          $map
            .parent()
            .addClass('page-width map-section--load-error')
            .html('<div class="errors text-center">' + errorMessage + '</div>');
        });
    },

    onUnload: function() {
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars
function gm_authFailure() {
  $('.map-section').addClass('map-section--load-error');
  $('.map-section__container').remove();
  $('.map-section__link').remove();
  $('.map-section__overlay').after('<div class="errors text-center">' + theme.strings.authError + '</div>');
}

/* eslint-disable no-new */
theme.Product = (function() {
  function Product(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      imageSize: null,
      imageZoomSize: null,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false
    };

    this.selectors = {
      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
      originalPrice: '#ProductPrice-' + sectionId,
      SKU: '.variant-sku',
      originalPriceWrapper: '.product-price__price-' + sectionId,
      originalSelectorId: '#ProductSelect-' + sectionId,
      productFeaturedImage: '#FeaturedImage-' + sectionId,
      productImageWrap: '#FeaturedImageZoom-' + sectionId,
      productPrices: '.product-single__price-' + sectionId,
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      saleClasses: 'product-price__sale product-price__sale--single',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId
    }

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(document.getElementById('ProductJson-' + sectionId).innerHTML);

    this.settings.zoomEnabled = $(this.selectors.productFeaturedImage).hasClass('js-zoom-enabled');
    this.settings.imageSize = theme.Images.imageSize($(this.selectors.productFeaturedImage).attr('src'));

    if (this.settings.zoomEnabled) {
      this.settings.imageZoomSize = theme.Images.imageSize($(this.selectors.productImageWrap).data('zoom'));
    }

    this._initBreakpoints();
    this._stringOverrides();
    this._initVariants();
    this._initImageSwitch();
    this._setActiveThumbnail();

    // Pre-loading product images to avoid a lag when a thumbnail is clicked, or
    // when a variant is selected that has a variant image
    theme.Images.preload(this.productSingleObject.images, this.settings.imageSize);
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function() {
      var self = this;

      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {
          // initialize thumbnail slider on mobile if more than three thumbnails
          if ($(self.selectors.productThumbImages).length > 3) {
            self._initThumbnailSlider();
          }

          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            _destroyZoom($(self.selectors.productImageWrap));
          }

          self.settings.bpSmall = true;
        },
        unmatch: function() {
          if (self.settings.sliderActive) {
            self._destroyThumbnailSlider();
          }

          self.settings.bpSmall = false;
        }
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function() {
          if (self.settings.zoomEnabled) {
            _enableZoom($(self.selectors.productImageWrap));
          }
        }
      });
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on('variantChange' + this.settings.namespace, this._updateAddToCart.bind(this));
      this.$container.on('variantImageChange' + this.settings.namespace, this._updateImages.bind(this));
      this.$container.on('variantPriceChange' + this.settings.namespace, this._updatePrice.bind(this));
      this.$container.on('variantSKUChange' + this.settings.namespace, this._updateSKU.bind(this));
    },

    _initImageSwitch: function() {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbImages).on('click', function(evt) {
        evt.preventDefault();
        var $el = $(this);
        var imageSrc = $el.attr('href');
        var zoomSrc = $el.data('zoom');

        self._switchImage(imageSrc, zoomSrc);
        self._setActiveThumbnail(imageSrc);
      });
    },

    _setActiveThumbnail: function(src) {
      var activeClass = 'active-thumb';

      // If there is no element passed, find it by the current product image
      if (typeof src === 'undefined') {
        src = $(this.selectors.productFeaturedImage).attr('src');
      }

      // Set active thumbnails (incl. slick cloned thumbs) with matching 'href'
      var $thumbnail = $(this.selectors.productThumbImages + '[href="' + src + '"]');
      $(this.selectors.productThumbImages).removeClass(activeClass);
      $thumbnail.addClass(activeClass);
    },

    _switchImage: function(image, zoomImage) {
      $(this.selectors.productFeaturedImage).attr('src', image);

      // destroy image zooming if enabled
      if (this.settings.zoomEnabled) {
        _destroyZoom($(this.selectors.productImageWrap));
      }

      if (!this.settings.bpSmall && this.settings.zoomEnabled && zoomImage) {
        $(this.selectors.productImageWrap).data('zoom', zoomImage);
        _enableZoom($(this.selectors.productImageWrap));
      }
    },

    _initThumbnailSlider: function() {
      var options = {
        slidesToShow: 4,
        slidesToScroll: 3,
        infinite: false,
        prevArrow: '.thumbnails-slider__prev--' + this.settings.sectionId,
        nextArrow: '.thumbnails-slider__next--' + this.settings.sectionId,
        responsive: [
          {
            breakpoint: 321,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      };

      $(this.selectors.productThumbs).slick(options);
      this.settings.sliderActive = true;
    },

    _destroyThumbnailSlider: function() {
      $(this.selectors.productThumbs).slick('unslick');
      this.settings.sliderActive = false;
    },

    _updateAddToCart: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.productPrices)
          .removeClass('visibility-hidden')
          .attr('aria-hidden', 'true');

        if (variant.available) {
          $(this.selectors.addToCart).prop('disabled', false);
          $(this.selectors.addToCartText).text(theme.strings.addToCart);
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          $(this.selectors.addToCart).prop('disabled', true);
          $(this.selectors.addToCartText).text(theme.strings.soldOut);
        }
      } else {
        $(this.selectors.addToCart).prop('disabled', true);
        $(this.selectors.addToCartText).text(theme.strings.unavailable);
        $(this.selectors.productPrices)
          .addClass('visibility-hidden')
          .attr('aria-hidden', 'false');
      }
    },

    _updateImages: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
      var zoomSizedImgUrl;

      if (this.settings.zoomEnabled) {
        zoomSizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageZoomSize);
      }

      this._switchImage(sizedImgUrl, zoomSizedImgUrl);
      this._setActiveThumbnail(sizedImgUrl);
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;

      // Update the product price
      $(this.selectors.originalPrice).html(theme.Currency.formatMoney(variant.price, theme.moneyFormat));

      // Update and show the product's compare price if necessary
      if (variant.compare_at_price > variant.price) {
        $(this.selectors.comparePrice)
          .html(theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat))
          .removeClass('hide');

        $(this.selectors.originalPriceWrapper).addClass(this.selectors.saleClasses);

        $(this.selectors.saleLabel).removeClass('hide');
      } else {
        $(this.selectors.comparePrice).addClass('hide');
        $(this.selectors.saleLabel).addClass('hide');
        $(this.selectors.originalPriceWrapper).removeClass(this.selectors.saleClasses);
      }
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;

      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
    }
  });

  function _enableZoom($el) {
    var zoomUrl = $el.data('zoom');
    $el.zoom({
      url: zoomUrl
    });
  }

  function _destroyZoom($el) {
    $el.trigger('zoom.destroy');
  }

  return Product;
})();

theme.Quotes = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    slideCount: 0
  };
  var defaults = {
    accessibility: true,
    arrows: true,
    dots: true,
    autoplay: false,
    autoplaySpeed: 5000,
    touchThreshold: 20,
    slidesToShow: 3,
    slidesToScroll: 3
  };

  function Quotes(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var wrapper = this.wrapper = '.quotes-wrapper';
    var slider = this.slider = '#Quotes-' + sectionId;
    var $slider = $(slider, wrapper);

    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

    config.slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function() {
        initSlider($slider, mobileOptions);
      }
    });

    enquire.register(config.mediaQueryMediumUp, {
      match: function() {
        initSlider($slider, defaults);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function() {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $('.quotes-slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Quotes;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;

    $('.slideshow__video', slideshow).each(function() {
      var $el = $(this);
      theme.SlideshowVideo.init($el);
      theme.SlideshowVideo.loadVideo($el.attr('id'));
    });

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {
  onUnload: function() {
    delete theme.slideshows[this.slideshow];
  },

  onBlockSelect: function(evt) {
    var $slideshow = $(this.slideshow);

    // Ignore the cloned version
    var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function() {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  }
});


$(document).ready(function() {
  var sections = new theme.Sections();

  function mobileNav() {

    $('.menu-button').on('click', function() {
       if ( $(this).hasClass('active') ) {
         $(this).removeClass('active');
         $('#mobile-links').removeClass('active');
       } else {
         $(this).addClass('active');
         $('#mobile-links').addClass('active');
       }
    });
  }

  mobileNav();

  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
    if ($('#agree').is(':checked')) {
      $(this).submit();
    }
    else {
      alert("You must agree with the terms and conditions of sales to check out.");
      return false;
    }
  });

  $('#slideshow-featured-stylist').slick({
    fade: true,
    dots: true,
    prevArrow: '<a href="#" class="arrow-left"><svg class="icon-slide-nav-left" viewBox="-11091 -18027 99.684 42.066"><defs><style>.icon-slide-nav-left {width:99.68px;} .icon-slide-nav-left .cls-1{fill:#fff;}</style></defs><g transform="translate(-11091 -18027)"><path d="M201.484,77.2c-.028.028-.056.028-.085.056a.028.028,0,0,1,.028.028Z" transform="translate(-144.69 -55.559)"/><path class="cls-1" d="M98.826,16.178a16.92,16.92,0,0,1-2.282-2.648.028.028,0,0,1,.028-.028c-.2-.479-.592-.817-1.07-.648a11.845,11.845,0,0,1-4.112.254c-1.634-.028-3.408-.169-4.619,1.408-1.183.479-2.31,1.324-3.634.282-.338-.254-.7.085-1.014.2a4.755,4.755,0,0,1-3.774-.169,7.748,7.748,0,0,0-5.155-.451c-.845.2-1.718.028-2.451.282a3.313,3.313,0,0,1-2.676.113c-.958-.592-1.606.254-2.394.085a.849.849,0,0,1-.479-.225,1.687,1.687,0,0,1-.282-.7c0-.085.253-.282.394-.31.423-.085.873-.141,1.324-.2a.539.539,0,0,0-.479-.479A26.456,26.456,0,0,1,61,11.953a1.72,1.72,0,0,0-1.324.282.888.888,0,0,1-1.042,0,1.563,1.563,0,0,1-.169-.225c-.282-.507-.7-.7-1.1-.282-1.07,1.1-2.028,1.07-3.127.028a1.774,1.774,0,0,0-1.859-.225,1.963,1.963,0,0,1-2.253-.282c-.338-.31-.873-.169-1.324.056-.31.169-.732.394-1.014.31a3.336,3.336,0,0,0-2.451.113c-.789.394-1.69-.282-2.394.31-.7-.479-1.465.282-2.056,0a4.417,4.417,0,0,0-3.774.225,3.177,3.177,0,0,1-1.352.141c-.732-.056-1.549-.732-2.141-.056-.9.958-1.493.028-2.225-.113-.225-.056-.507.2-.732.31a2.529,2.529,0,0,1-1.634.254c-.451-.085-1.155-.113-1.268-.366-.282-.62.423-.9.845-1.239.7-.62,1.408-1.211,2.113-1.859a12.556,12.556,0,0,0,2.76-3.549,2.992,2.992,0,0,0-1.69-4.507c-.648-.225-1.042-.845-1.69-.9-.732-.056-1.493.169-2.225.141a2.591,2.591,0,0,0-1.3.394,37.619,37.619,0,0,0-5.408,2.76.958.958,0,0,1-.761.141c-.423-.254-.62-.225-.845.225-.225.507-.141,1.127-.648,1.521a.541.541,0,0,1-.789-.282c-.282-.563-.732-.789-1.127-.563-.563.31-.761,1.239-1.521,1.07a3.678,3.678,0,0,0-2.394.507c-1.493.563-2.9,1.3-4.366,1.8A4.5,4.5,0,0,0,6.185,9.7c-.62.9-1.8.93-2.563,1.634a1.562,1.562,0,0,0-.169.225C2.073,13.784.693,16.009.777,18.8a14.975,14.975,0,0,1-.451,3.324c-.2.93-.676,1.8.507,2.451.31.169.113.507,0,.761a3.163,3.163,0,0,0-.394,1.042c0,.648.7.423,1.042.676.282.225.62.423.9.648a10.71,10.71,0,0,0,4.366,2.394,6.242,6.242,0,0,1,2.31.986,38.113,38.113,0,0,0,5.155,2.845c3.127,1.465,6.14,3.183,9.211,4.788.648.338,1.437.535,1.38,1.549-.028.225.225.282.423.141.789-.592,1.155-.254,1.352.592.085.366.394.282.62.085.592-.507.986-.31,1.324.31a5.451,5.451,0,0,0,.648.761l-.028.028c.31.254.62.423.93,0,.113-.141.056-.366.141-.535.394-.732.9-1.38,1.268-2.169.451-1.042-.648-1.746-.338-2.676a.976.976,0,0,0-.535-1.155c-1.183-.7-2.394-1.38-3.634-2A19.533,19.533,0,0,1,21.4,30.037a6.289,6.289,0,0,0-2.338-1.493,2.973,2.973,0,0,1-1.972-1.831c-.2-.592-.817-.648-1.239-.958h0c.254-.282-.366-.113-.028-.282a4.848,4.848,0,0,1,2.873-.423,8.143,8.143,0,0,0,1.634.225c2.62-.113,5.155.7,7.774.479,2.084.648,4.253.254,6.366.676a4.657,4.657,0,0,0,2.141-.225c.253-.056.423-.535.62-.845.282.254.535.507.817.732a1.6,1.6,0,0,0,1.324.254,6.4,6.4,0,0,1,2.2.028,33.772,33.772,0,0,0,4.141.394c.338.028,1.014-.113,1.014-.225.028-.648-.563-.507-.958-.592-.732-.113-.423-.676-.479-1.07-.084-.592-.338-.676-.873-.338-1.014.648-1.324.507-1.577-.789a.766.766,0,0,1,0-.254c.479-.225,1.014-.676,1.465-.648,1.1.113,2.2-.028,3.239.085,2.507.282,4.986-.085,7.436,0,.873.028,1.268-.507,1.8-.873A3.287,3.287,0,0,0,54.66,21.5c-.563.028-1.127.085-1.69.085a7.7,7.7,0,0,1-1.38-.169c-.254-.056-.535-.169-.394-.507a.555.555,0,0,1,.423-.282,38.6,38.6,0,0,0,4.422.028c1.718-.225,3.521.7,5.155-.451.2-.141.535-.028.817,0,1.211.028,2.422.113,3.634.085,2.789-.085,5.605.366,8.366-.282,1.437-.338,2.76.282,4.169.366.113,0,.225.169.366.254-.169.085-.31.282-.479.254-1.944-.141-3.887.366-5.859.225-1.465-.085-2.929.423-4.422.338-.254,0-.451.338-.423.648.028.169.113.394.253.451a6.6,6.6,0,0,0,2.451.423c1.634.028,3.3.169,4.929.254a.691.691,0,0,1,.7.676,1.442,1.442,0,0,0,.225.789c.282.366.648.113,1.014.028.254-.056.62-.085.761.056.7.732,1.211.62,1.775-.2a.87.87,0,0,1,1.408-.028,4.337,4.337,0,0,1,.423.986c.141.31.535.338.62.113.366-.986,1.239-.845,2-1.1.732-.225,1.127-.282,1.69.31.423.451.9.2,1.3-.451.141-.225.225-.563.423-.648a1.043,1.043,0,0,1,.817.056c.338.169.563.479.9.648.225.113.62.282.761.169,1.211-.873,2.7-.7,4.028-1.1a8.989,8.989,0,0,0,5.352-4.2A2.081,2.081,0,0,0,98.826,16.178ZM9.537,9.475l-.056-.141h.141ZM29.282,41.5c.028.085.141.169.113.2l-.254.338A.394.394,0,0,1,29.282,41.5ZM23.93,24.009l-.141-.141a.505.505,0,0,1,.2-.141c.085.028.141.028.225.056C24.1,23.868,24.015,23.953,23.93,24.009Zm7.211.986c-.056.028-.169-.028-.254-.028,0-.056-.028-.169,0-.2a.284.284,0,0,1,.254-.085C31.394,24.741,31.423,24.882,31.141,24.995Zm1.887.084c-.084.225-.563.169-.732-.056a.98.98,0,0,1-.225-1.014c.169-.423.592-.451.958-.451.141,0,.282.2.394.282C33.282,24.234,33.2,24.685,33.028,25.079Zm2.986-.592c-.056.451.141,1.014-.535,1.014-.507,0-.761-.479-.9-.93a1.512,1.512,0,0,1,.31-1.324c.085-.141.31-.2.479-.282.169.056.366.085.451.2A1.907,1.907,0,0,1,36.014,24.488Zm2.169-3.155a.285.285,0,0,1-.282-.394.9.9,0,0,1,.254-.423,1.584,1.584,0,0,1,.507-.2,5.042,5.042,0,0,1,2.422.254c.056,0,.085.141.085.2a.348.348,0,0,1-.113.225c-.141.113-.282.282-.451.31C39.816,21.333,39,21.333,38.183,21.333Zm1.1,2.141c-.253.028-.31-.085-.2-.254a.219.219,0,0,1,.225-.056c.056,0,.085.085.141.141C39.394,23.389,39.337,23.474,39.281,23.474Zm.93,2.225c-.056.056-.479-.225-.592-.423-.141-.282-.479-.732-.085-.986a16.076,16.076,0,0,1,2.394-1.239c.366-.169.676.141.873.507h0C42.408,24.8,41.112,25.051,40.211,25.7Zm7.408-4.028a.772.772,0,0,1-.958.338,5.217,5.217,0,0,1-.93-.592c-.141-.113-.282-.31-.253-.451s.253-.254.394-.338a.379.379,0,0,1,.225-.056,4.814,4.814,0,0,1,.873-.085c.394,0,.789.113.9.507C47.928,21.164,47.759,21.474,47.618,21.671Zm.563-8.76c-.056-.056-.2-.113-.2-.169a.453.453,0,0,1,.451-.535.251.251,0,0,1,.225.141C48.773,12.545,48.407,12.939,48.182,12.911Zm5.3,3.521a2.208,2.208,0,0,0-.141.394C53.055,16.488,53.252,16.46,53.477,16.432Zm1.859,2.7a1.356,1.356,0,0,1-1.3.338c-.056-.028-.113-.113-.169-.169a.487.487,0,0,1,.028-.282.981.981,0,0,1,1.408-.366A.428.428,0,0,1,55.336,19.136Zm.31-2.394a.709.709,0,0,1-.845.394c-.2-.028-.225-.225-.056-.366.2-.169.423-.282.62-.423a1.562,1.562,0,0,1,.225.169A.234.234,0,0,1,55.646,16.742Zm1.38-2.451a.814.814,0,0,1-.62.366c-.169-.028-.394-.366-.423-.592s.084-.563.394-.507C56.857,13.643,57.2,14.038,57.026,14.291Zm1.352,5.521a4.329,4.329,0,0,1-.479-.535s.085-.169.169-.169c.338-.085.479.085.563.394C58.547,19.615,58.463,19.7,58.378,19.812Zm3.465-2.2a2.578,2.578,0,0,1-.451-.028c.056-.113.113-.338.169-.338.141,0,.282.113.451.169C61.955,17.5,61.9,17.615,61.843,17.615Zm1.408-1.465a3.047,3.047,0,0,1-.507,0c.056-.31.338-.225.507-.254.056,0,.141.085.225.113C63.392,16.038,63.336,16.15,63.251,16.15ZM73,16.685a1.3,1.3,0,0,1-.789-.084c-.085-.028-.169-.31-.113-.451.113-.338.423-.338.7-.282a4.3,4.3,0,0,1,.7.254C73.335,16.319,73.222,16.6,73,16.685Zm5.774,6.845a.634.634,0,0,1-.141-.141.505.505,0,0,1,.2-.141c.084.028.141.028.225.056C78.968,23.361,78.884,23.446,78.771,23.53Zm3.38-2.845c-.141.028-.31-.085-.479-.141.141-.085.282-.169.451-.282.169.056.31.113.479.169C82.461,20.516,82.32,20.685,82.151,20.685Z" transform="translate(-0.062 -0.368)"/><path d="M236.456,46.5H236.4v.084Z" transform="translate(-169.831 -33.506)"/></g></svg></a>',
    nextArrow:'<a href="#" class="arrow-right"><svg class="icon-slide-nav-right" viewBox="-9322 -18028 83.377 45.158"><defs><style>.icon-slide-nav-right {width:83.38px;height:45.16px;}.icon-slide-nav-right .cls-1 {fill:#fff;}</style></defs><g transform="translate(-9322 -18028)"><path d="M144.913,118.056c-.028,0-.056-.028-.085-.056H144.8Z" transform="translate(-103.999 -84.791)"/><path d="M145.4,120.085c.028-.028.056-.028.085-.056a.028.028,0,0,0-.028-.028Z" transform="translate(-104.43 -86.228)"/><path d="M197.885,121.328c-.028,0-.028-.028-.056-.028H197.8Z" transform="translate(-142.07 -87.162)"/><path d="M4.5,73.7c.028.028.028.056.056.085l.028-.028Z" transform="translate(-3.217 -52.969)"/><path class="cls-1" d="M83.221,26.577c-.254-1.831-.732-3.634-1.042-5.493a6.982,6.982,0,0,1-.2-3.155c.394-1.352.2-1.408-1.07-2.084-.986-.535-1.972-1.042-2.9-1.606a1.116,1.116,0,0,1-.676-1.127c.084-.592-.282-.873-.732-1.042-1.211-.451-2.479-.845-3.69-1.324-.761-.31-1.69-.338-2.225-1.127-1.493-.423-2.648-1.549-4.366-1.606a4.048,4.048,0,0,1-3.774-2.028c-.253-.479-.732-.563-1.127-.761-.761-.366-1.521-.732-2.282-1.07C58.293,3.762,57.589,3.058,56.6,3c-.085.085-.2.169-.282.254.028-.113.028-.254.056-.366-.394-.366-.873-.958-1.38-.817-.817.254-1.352-.2-1.972-.479-.338-.141-.7-.254-1.042-.394-.507-.225-.789,0-1.183.338-.62.507-1.183.169-1.239-.676-.028-.254.169-.507.253-.761l-.056.085c-1.775-.056-1.8-.028-2.113,1.408A6.131,6.131,0,0,1,47.224,3.2a3.633,3.633,0,0,0-.2,1.634A.93.93,0,0,0,47.7,5.9c.366.113.732.2,1.07.31s.451.479.225.62c-.141.113-.338.282-.479.254-.648-.113-1.268-.338-1.887-.479a1.256,1.256,0,0,0-1.324.817A12.72,12.72,0,0,1,44.8,9.536c-.648,1.324-.169,2.253,1.1,2.986a4.2,4.2,0,0,0,1.042.394c3.155,1.155,6.309,2.253,9.436,3.493a22.964,22.964,0,0,1,4.957,2.563.651.651,0,0,1,.282.93.73.73,0,0,1-.93.423c-.986-.254-1.972-.507-2.958-.789a1.478,1.478,0,0,0-1.577.254.839.839,0,0,1-1.239.085,4.14,4.14,0,0,0-3.408-.958,1.369,1.369,0,0,1-.817-.141c-.873-.563-1.775-.282-2.676-.225-.648.056-1.3-.113-1.944-.085-.732.056-1.493-.338-2.169.225-.732.62-.958-.676-1.69-.423-.479.169-1.042-.085-1.549.394-.873.845-1.915.535-2.873.113a4.115,4.115,0,0,1-.93-.62.983.983,0,0,0-1.465.085,4.49,4.49,0,0,1-.592.423,3.093,3.093,0,0,0,1.8,1.493c.479.113.394.338-.282.761-.169.113-.2.028-.225-.028V21c0,.113.169.338.253.338a10.064,10.064,0,0,0,1.324-.113,3.622,3.622,0,0,1-.113-.535c.028-1.1.648-1.493,1.634-1.014.113.056.254.338.2.423a3.361,3.361,0,0,1-1.38,1.352c-.648.592-1.3,1.239-1.972,1.8a1.793,1.793,0,0,1-.986.394q-2.2.127-4.394.169a.348.348,0,0,1-.225-.113c-.056-.028-.085-.085-.141-.113-.535.141-1.1.254-1.634.394-.2-.169-.451-.338-.507-.563a1.947,1.947,0,0,0-2.422-1.352,5.378,5.378,0,0,1-2.225-.085c-.254-.085-.338-.169-.2-.338a.613.613,0,0,1,.225-.141,3.913,3.913,0,0,0,.535-.169,2.246,2.246,0,0,0,.451-.225c-.141-.113-.254-.282-.394-.31a3.02,3.02,0,0,0-1.1-.2c-2.366.282-4.732,1.07-7.126,0a.546.546,0,0,0-.507.085c-1.3.958-2.929.507-4.338.986-.113.225-.225.479-.507.225-.056-.028.085-.282.141-.423.169-.31.535-.676.479-.93-.141-.563-.7-.451-1.127-.366-.563.085-1.1.225-1.634.338a6.343,6.343,0,0,1-3.549.225,1.926,1.926,0,0,0-1.8.535c-.732.592-1.324.282-1.8-.366A2.842,2.842,0,0,0,.1,24.3a18.863,18.863,0,0,0,1.211,2.817c.113.225.535.338.366.62A1.05,1.05,0,0,0,2.1,29.365c.873.563-.535,1.662.507,2.253.056.028-.085.507-.225.732a5.039,5.039,0,0,1-.7.873c-.225.225-.282.479-.028.676a.535.535,0,0,0,.761-.028,1.628,1.628,0,0,1,2-.535c.394.169.366-.225.507-.451.507-.817.535-.817,1.3-.028.113.141.225.394.338.394a17.212,17.212,0,0,1,2.084.479,1.986,1.986,0,0,0,1.549-.535,10.2,10.2,0,0,1,1.155-.761c.789-.479.817-.451,1.577.592a1.079,1.079,0,0,0,.676.366c.31.028.394-.282.451-.535.282-1.07.394-1.127,1.211-.789.254.113.479.31.732.394.62.2,1.1.338,1.69-.31a3.631,3.631,0,0,1,3.127-.873c.9.113,1.831.31,2.732.366.789.056,1.437.141,1.831.986a1.376,1.376,0,0,0,.93.507c1.38.225,2.76.394,4.141.563a1.079,1.079,0,0,0,1.3-.789c.141-.423.535-.592.817-.169.451.676,1.211.845,1.831,1.239.451.31.93.648.958,1.3,0,.366.2.535.507.366s.563-.592.873-.648c1.042-.225.958-.958.986-1.718,0-.394.056-.761.563-.338a3.546,3.546,0,0,0,1.859.507l-.028.085a1.839,1.839,0,0,1,.423-.282c.028-.028.113.028.169.056.141.028.366.028.423.113.141.225,0,.366-.169.479.056.056.085.141.169.169.563.254.9.479.113.9a.494.494,0,0,0-.056.451c.056.141.31.31.394.254.479-.2.958-.423,1.437-.648a3.043,3.043,0,0,0,2.479.676,9.738,9.738,0,0,1,2.7-.2c.451.028.563-.535.254-1.042-.085-.141-.254-.225-.394-.366a2.353,2.353,0,0,1,2.9-.451c.7.31.676.648-.056,1.155a.618.618,0,0,0-.282.394.459.459,0,0,0,.31.366c.845.2,1.606-.056,1.831-.732.169-.507.113-1.268.62-1.437.732-.254.423,1.183,1.268,1.042l-.028.056c.282-.423.592-.761,1.127-.366h.225c.338,0,.761-.085.9.31.141.451-.31.535-.592.7-.085.056-.141.085-.225.141l.028-.056a23.339,23.339,0,0,0-2.535,7.07c-.141.62.338.986,1.014.817.958-.253.958-.253,1.183.394.056.169.084.366.141.535.394,1.127.479,1.183,1.577,1.211a4.128,4.128,0,0,0,2.873-.7,4.274,4.274,0,0,0,1.268-1.07c.507-.592,1.042.2,1.549-.085a5.684,5.684,0,0,0,1.211-.7,5.772,5.772,0,0,1,1.972-1.042A21.2,21.2,0,0,0,70.912,39.7a42.692,42.692,0,0,1,4.169-2.253,28.194,28.194,0,0,0,4-2.366C82.122,33.14,83.756,30.323,83.221,26.577ZM3.593,31.591s-.028-.141,0-.169c.028-.056.113-.085.169-.113C3.819,31.506,3.762,31.591,3.593,31.591Zm.873-.563a6.117,6.117,0,0,1-.676.2.479.479,0,0,1,.366-.563c.141-.028.31.085.451.141C4.579,30.886,4.551,31,4.466,31.027Zm17.1-9.267c.028.423-.7.451-1.127.479-.2,0-.394-.225-.563-.366a2.209,2.209,0,0,1,.676-.254C20.916,21.591,21.507,21.169,21.564,21.76Zm-1.887-.028c.028.028.056.056.056.085-.085-.028-.141-.056-.225-.085C19.564,21.732,19.648,21.7,19.677,21.732Zm-12.731.2c-.028-.338.31-.254.479-.338a2.5,2.5,0,0,1,.592-.169c.31-.056.676-.085,1.014-.169.2-.056.31,0,.423.2.085.141-.2.563-.394.676a2.112,2.112,0,0,1-1.606-.056C7.283,22.014,6.945,21.986,6.945,21.929ZM18.24,27.253a.421.421,0,0,1,.2-.085c.028,0,.113.113.113.113C18.381,27.422,18.268,27.422,18.24,27.253Zm7.605,2.028c-.282.113-.845-.169-.817-.394.028-.141.169-.338.282-.338a1.639,1.639,0,0,1,.732.085C26.183,28.661,26.042,29.2,25.845,29.281Zm.366,2.845c.028.028.056.028.056.056-.085,0-.141-.028-.225-.028C26.1,32.154,26.183,32.1,26.211,32.126Zm.282.169c.394-.056.789-.282,1.1.2A.773.773,0,0,1,26.493,32.295Zm1.239.423c-.056-.056-.056-.113-.085-.2.2-.056.31.028.282.2C27.929,32.717,27.76,32.745,27.732,32.717Zm3.436-.9.056-.141.085.141Zm5.07-5.971c-.817,1.042-.873,1.042-2.169.62-.282.056-.592.225-.817.169-2.141-.789-4.422-.085-6.563-.789a.781.781,0,0,0-.789.113,3.585,3.585,0,0,1-3.239.366,2.95,2.95,0,0,0-2.394.169c-.141.085-.507,0-.507-.056-.141-1.437-1.577-.451-2.141-1.155a.571.571,0,0,0-.507-.085c-.873,1.268-1.8.845-2.789.2-1.465.2-2.958.366-4.422.592a2.969,2.969,0,0,1-1.915-.141.3.3,0,0,1-.113-.169c.028-.085.113-.2.169-.2,2.479-.338,4.957-.761,7.464-.958a40.947,40.947,0,0,1,6.7-.254c1.042.085,2.253.056,2.873-.761.648-.845.789-.592,1.268.028a1.98,1.98,0,0,0,2.253.535.589.589,0,0,0,.169.113,10.126,10.126,0,0,0,3.324.028c1.014,0,1.972.535,3.042.2,1.07-.366,1.746.225,2.141,1.183A1.332,1.332,0,0,1,36.239,25.845Zm8.675-2.929c.028,0,.056.085.085.141a.421.421,0,0,1-.2.085c-.028,0-.056-.085-.085-.141A.6.6,0,0,1,44.914,22.915Zm-.958-2.789c.423-.2.676.056.873.394.028.056-.141.254-.225.394-.085,0-.2.056-.254,0-.225-.113-.451-.254-.676-.394C43.787,20.38,43.844,20.183,43.956,20.127Zm-5.267,4.028a.219.219,0,0,1,.225-.056,2.349,2.349,0,0,1,.338.225c-.113.028-.253.085-.366.113C38.633,24.464,38.548,24.352,38.689,24.155Zm1.1,1.972c-.225.028-.592-.028-.676-.2-.169-.282.141-.423.366-.507a5.355,5.355,0,0,1,.7-.085C40.154,25.676,40.238,26.07,39.788,26.126Zm.394-.845a1.814,1.814,0,0,1-.789-.93,3.078,3.078,0,0,1,.479-.141c.732-.113,1.127.028,1.1.423C40.914,25.084,40.548,25.2,40.182,25.281Zm-.225-1.944a.992.992,0,0,1-.479-.592.981.981,0,0,1,.338-.676.6.6,0,0,1,.507-.113c.282.028.62.113.676-.225.028-.169-.31-.366-.479-.592-.113-.141-.732.085-.366-.394.169-.225.394-.789.845-.507.507.31,1.324.366,1.268,1.268-.028.62.592.9.761,1.437a.939.939,0,0,1-.282.958C41.9,23.2,40.8,23.732,39.957,23.338ZM42.21,25.76c-.056.056-.169.028-.253.028-.028-.056-.113-.141-.085-.169.056-.056.113-.141.2-.141C42.323,25.478,42.379,25.591,42.21,25.76Zm0-1.211c.028-.113.028-.282.113-.338a1.067,1.067,0,0,1,.366-.169c.056.141.084.282.141.423a2.208,2.208,0,0,1-.394.141C42.379,24.633,42.295,24.577,42.21,24.549Zm.873,10.422c0-.056.028-.113.028-.169C43.252,34.858,43.224,34.886,43.083,34.971Zm.169-9.239a5.453,5.453,0,0,1-.31-1.211,1.2,1.2,0,0,1,1.1.563.9.9,0,0,1-.141.732A.382.382,0,0,1,43.252,25.732Zm1.606,8.112a3.235,3.235,0,0,1-.507.028c-.141-.056-.338-.2-.366-.338a.423.423,0,0,1,.423-.507,1.054,1.054,0,0,1,.507.141,1.415,1.415,0,0,1,.338.366C45.139,33.619,45,33.731,44.858,33.844Zm1.352,1.211.056-.141.084.141Zm.141-9.351c-.225.028-.338-.113-.2-.282a.851.851,0,0,1,.451-.141c.028,0,.084.113.141.141A.934.934,0,0,1,46.351,25.7Zm.056-5.155a.593.593,0,0,1,.676-.62,1.878,1.878,0,0,1,1.1.676,5.109,5.109,0,0,1-.676.676A.751.751,0,0,1,46.407,20.549Zm1.155,13.21c.085-.2.254-.2.338.028a1.486,1.486,0,0,1,.085.338c-.113-.056-.254-.085-.366-.141A.234.234,0,0,1,47.562,33.759Zm2.394-13.041c-.169-.028-.31-.056-.479-.085l.169-.338a3.376,3.376,0,0,0,.338.31c.085.056.2.141.282.2A1.27,1.27,0,0,1,49.956,20.718Zm2.648.225c-.31.225-.845-.169-.93-.648-.056-.366.253-.761.563-.732s.592.338.676.817C52.829,20.521,52.773,20.831,52.6,20.944Z" transform="translate(0.056 -0.1)"/><path d="M123.4,66.013c.028-.028.056-.028.085-.056,0-.028-.028-.028-.028-.056Z" transform="translate(-88.626 -47.366)"/><path d="M107.4,83.2l.056.056h.028Z" transform="translate(-77.133 -59.793)"/><path d="M128.3,73.817c.028-.056,0-.028,0,0Z" transform="translate(-92.146 -53.03)"/></g></svg></a>',
    autoplaySpeed: 5000,
  });

  $('#hero-slider').slick({
    fade: true,
    dots: true,
    autoplay: false,
    prevArrow: '<a href="#" class="arrow-left"><svg class="icon-slide-nav-left" viewBox="-11091 -18027 99.684 42.066"><defs><style>.icon-slide-nav-left {width:99.68px;} .icon-slide-nav-left .cls-1{fill:#fff;}</style></defs><g transform="translate(-11091 -18027)"><path d="M201.484,77.2c-.028.028-.056.028-.085.056a.028.028,0,0,1,.028.028Z" transform="translate(-144.69 -55.559)"/><path class="cls-1" d="M98.826,16.178a16.92,16.92,0,0,1-2.282-2.648.028.028,0,0,1,.028-.028c-.2-.479-.592-.817-1.07-.648a11.845,11.845,0,0,1-4.112.254c-1.634-.028-3.408-.169-4.619,1.408-1.183.479-2.31,1.324-3.634.282-.338-.254-.7.085-1.014.2a4.755,4.755,0,0,1-3.774-.169,7.748,7.748,0,0,0-5.155-.451c-.845.2-1.718.028-2.451.282a3.313,3.313,0,0,1-2.676.113c-.958-.592-1.606.254-2.394.085a.849.849,0,0,1-.479-.225,1.687,1.687,0,0,1-.282-.7c0-.085.253-.282.394-.31.423-.085.873-.141,1.324-.2a.539.539,0,0,0-.479-.479A26.456,26.456,0,0,1,61,11.953a1.72,1.72,0,0,0-1.324.282.888.888,0,0,1-1.042,0,1.563,1.563,0,0,1-.169-.225c-.282-.507-.7-.7-1.1-.282-1.07,1.1-2.028,1.07-3.127.028a1.774,1.774,0,0,0-1.859-.225,1.963,1.963,0,0,1-2.253-.282c-.338-.31-.873-.169-1.324.056-.31.169-.732.394-1.014.31a3.336,3.336,0,0,0-2.451.113c-.789.394-1.69-.282-2.394.31-.7-.479-1.465.282-2.056,0a4.417,4.417,0,0,0-3.774.225,3.177,3.177,0,0,1-1.352.141c-.732-.056-1.549-.732-2.141-.056-.9.958-1.493.028-2.225-.113-.225-.056-.507.2-.732.31a2.529,2.529,0,0,1-1.634.254c-.451-.085-1.155-.113-1.268-.366-.282-.62.423-.9.845-1.239.7-.62,1.408-1.211,2.113-1.859a12.556,12.556,0,0,0,2.76-3.549,2.992,2.992,0,0,0-1.69-4.507c-.648-.225-1.042-.845-1.69-.9-.732-.056-1.493.169-2.225.141a2.591,2.591,0,0,0-1.3.394,37.619,37.619,0,0,0-5.408,2.76.958.958,0,0,1-.761.141c-.423-.254-.62-.225-.845.225-.225.507-.141,1.127-.648,1.521a.541.541,0,0,1-.789-.282c-.282-.563-.732-.789-1.127-.563-.563.31-.761,1.239-1.521,1.07a3.678,3.678,0,0,0-2.394.507c-1.493.563-2.9,1.3-4.366,1.8A4.5,4.5,0,0,0,6.185,9.7c-.62.9-1.8.93-2.563,1.634a1.562,1.562,0,0,0-.169.225C2.073,13.784.693,16.009.777,18.8a14.975,14.975,0,0,1-.451,3.324c-.2.93-.676,1.8.507,2.451.31.169.113.507,0,.761a3.163,3.163,0,0,0-.394,1.042c0,.648.7.423,1.042.676.282.225.62.423.9.648a10.71,10.71,0,0,0,4.366,2.394,6.242,6.242,0,0,1,2.31.986,38.113,38.113,0,0,0,5.155,2.845c3.127,1.465,6.14,3.183,9.211,4.788.648.338,1.437.535,1.38,1.549-.028.225.225.282.423.141.789-.592,1.155-.254,1.352.592.085.366.394.282.62.085.592-.507.986-.31,1.324.31a5.451,5.451,0,0,0,.648.761l-.028.028c.31.254.62.423.93,0,.113-.141.056-.366.141-.535.394-.732.9-1.38,1.268-2.169.451-1.042-.648-1.746-.338-2.676a.976.976,0,0,0-.535-1.155c-1.183-.7-2.394-1.38-3.634-2A19.533,19.533,0,0,1,21.4,30.037a6.289,6.289,0,0,0-2.338-1.493,2.973,2.973,0,0,1-1.972-1.831c-.2-.592-.817-.648-1.239-.958h0c.254-.282-.366-.113-.028-.282a4.848,4.848,0,0,1,2.873-.423,8.143,8.143,0,0,0,1.634.225c2.62-.113,5.155.7,7.774.479,2.084.648,4.253.254,6.366.676a4.657,4.657,0,0,0,2.141-.225c.253-.056.423-.535.62-.845.282.254.535.507.817.732a1.6,1.6,0,0,0,1.324.254,6.4,6.4,0,0,1,2.2.028,33.772,33.772,0,0,0,4.141.394c.338.028,1.014-.113,1.014-.225.028-.648-.563-.507-.958-.592-.732-.113-.423-.676-.479-1.07-.084-.592-.338-.676-.873-.338-1.014.648-1.324.507-1.577-.789a.766.766,0,0,1,0-.254c.479-.225,1.014-.676,1.465-.648,1.1.113,2.2-.028,3.239.085,2.507.282,4.986-.085,7.436,0,.873.028,1.268-.507,1.8-.873A3.287,3.287,0,0,0,54.66,21.5c-.563.028-1.127.085-1.69.085a7.7,7.7,0,0,1-1.38-.169c-.254-.056-.535-.169-.394-.507a.555.555,0,0,1,.423-.282,38.6,38.6,0,0,0,4.422.028c1.718-.225,3.521.7,5.155-.451.2-.141.535-.028.817,0,1.211.028,2.422.113,3.634.085,2.789-.085,5.605.366,8.366-.282,1.437-.338,2.76.282,4.169.366.113,0,.225.169.366.254-.169.085-.31.282-.479.254-1.944-.141-3.887.366-5.859.225-1.465-.085-2.929.423-4.422.338-.254,0-.451.338-.423.648.028.169.113.394.253.451a6.6,6.6,0,0,0,2.451.423c1.634.028,3.3.169,4.929.254a.691.691,0,0,1,.7.676,1.442,1.442,0,0,0,.225.789c.282.366.648.113,1.014.028.254-.056.62-.085.761.056.7.732,1.211.62,1.775-.2a.87.87,0,0,1,1.408-.028,4.337,4.337,0,0,1,.423.986c.141.31.535.338.62.113.366-.986,1.239-.845,2-1.1.732-.225,1.127-.282,1.69.31.423.451.9.2,1.3-.451.141-.225.225-.563.423-.648a1.043,1.043,0,0,1,.817.056c.338.169.563.479.9.648.225.113.62.282.761.169,1.211-.873,2.7-.7,4.028-1.1a8.989,8.989,0,0,0,5.352-4.2A2.081,2.081,0,0,0,98.826,16.178ZM9.537,9.475l-.056-.141h.141ZM29.282,41.5c.028.085.141.169.113.2l-.254.338A.394.394,0,0,1,29.282,41.5ZM23.93,24.009l-.141-.141a.505.505,0,0,1,.2-.141c.085.028.141.028.225.056C24.1,23.868,24.015,23.953,23.93,24.009Zm7.211.986c-.056.028-.169-.028-.254-.028,0-.056-.028-.169,0-.2a.284.284,0,0,1,.254-.085C31.394,24.741,31.423,24.882,31.141,24.995Zm1.887.084c-.084.225-.563.169-.732-.056a.98.98,0,0,1-.225-1.014c.169-.423.592-.451.958-.451.141,0,.282.2.394.282C33.282,24.234,33.2,24.685,33.028,25.079Zm2.986-.592c-.056.451.141,1.014-.535,1.014-.507,0-.761-.479-.9-.93a1.512,1.512,0,0,1,.31-1.324c.085-.141.31-.2.479-.282.169.056.366.085.451.2A1.907,1.907,0,0,1,36.014,24.488Zm2.169-3.155a.285.285,0,0,1-.282-.394.9.9,0,0,1,.254-.423,1.584,1.584,0,0,1,.507-.2,5.042,5.042,0,0,1,2.422.254c.056,0,.085.141.085.2a.348.348,0,0,1-.113.225c-.141.113-.282.282-.451.31C39.816,21.333,39,21.333,38.183,21.333Zm1.1,2.141c-.253.028-.31-.085-.2-.254a.219.219,0,0,1,.225-.056c.056,0,.085.085.141.141C39.394,23.389,39.337,23.474,39.281,23.474Zm.93,2.225c-.056.056-.479-.225-.592-.423-.141-.282-.479-.732-.085-.986a16.076,16.076,0,0,1,2.394-1.239c.366-.169.676.141.873.507h0C42.408,24.8,41.112,25.051,40.211,25.7Zm7.408-4.028a.772.772,0,0,1-.958.338,5.217,5.217,0,0,1-.93-.592c-.141-.113-.282-.31-.253-.451s.253-.254.394-.338a.379.379,0,0,1,.225-.056,4.814,4.814,0,0,1,.873-.085c.394,0,.789.113.9.507C47.928,21.164,47.759,21.474,47.618,21.671Zm.563-8.76c-.056-.056-.2-.113-.2-.169a.453.453,0,0,1,.451-.535.251.251,0,0,1,.225.141C48.773,12.545,48.407,12.939,48.182,12.911Zm5.3,3.521a2.208,2.208,0,0,0-.141.394C53.055,16.488,53.252,16.46,53.477,16.432Zm1.859,2.7a1.356,1.356,0,0,1-1.3.338c-.056-.028-.113-.113-.169-.169a.487.487,0,0,1,.028-.282.981.981,0,0,1,1.408-.366A.428.428,0,0,1,55.336,19.136Zm.31-2.394a.709.709,0,0,1-.845.394c-.2-.028-.225-.225-.056-.366.2-.169.423-.282.62-.423a1.562,1.562,0,0,1,.225.169A.234.234,0,0,1,55.646,16.742Zm1.38-2.451a.814.814,0,0,1-.62.366c-.169-.028-.394-.366-.423-.592s.084-.563.394-.507C56.857,13.643,57.2,14.038,57.026,14.291Zm1.352,5.521a4.329,4.329,0,0,1-.479-.535s.085-.169.169-.169c.338-.085.479.085.563.394C58.547,19.615,58.463,19.7,58.378,19.812Zm3.465-2.2a2.578,2.578,0,0,1-.451-.028c.056-.113.113-.338.169-.338.141,0,.282.113.451.169C61.955,17.5,61.9,17.615,61.843,17.615Zm1.408-1.465a3.047,3.047,0,0,1-.507,0c.056-.31.338-.225.507-.254.056,0,.141.085.225.113C63.392,16.038,63.336,16.15,63.251,16.15ZM73,16.685a1.3,1.3,0,0,1-.789-.084c-.085-.028-.169-.31-.113-.451.113-.338.423-.338.7-.282a4.3,4.3,0,0,1,.7.254C73.335,16.319,73.222,16.6,73,16.685Zm5.774,6.845a.634.634,0,0,1-.141-.141.505.505,0,0,1,.2-.141c.084.028.141.028.225.056C78.968,23.361,78.884,23.446,78.771,23.53Zm3.38-2.845c-.141.028-.31-.085-.479-.141.141-.085.282-.169.451-.282.169.056.31.113.479.169C82.461,20.516,82.32,20.685,82.151,20.685Z" transform="translate(-0.062 -0.368)"/><path d="M236.456,46.5H236.4v.084Z" transform="translate(-169.831 -33.506)"/></g></svg></a>',
    nextArrow:'<a href="#" class="arrow-right"><svg class="icon-slide-nav-right" viewBox="-9322 -18028 83.377 45.158"><defs><style>.icon-slide-nav-right {width:83.38px;height:45.16px;}.icon-slide-nav-right .cls-1 {fill:#fff;}</style></defs><g transform="translate(-9322 -18028)"><path d="M144.913,118.056c-.028,0-.056-.028-.085-.056H144.8Z" transform="translate(-103.999 -84.791)"/><path d="M145.4,120.085c.028-.028.056-.028.085-.056a.028.028,0,0,0-.028-.028Z" transform="translate(-104.43 -86.228)"/><path d="M197.885,121.328c-.028,0-.028-.028-.056-.028H197.8Z" transform="translate(-142.07 -87.162)"/><path d="M4.5,73.7c.028.028.028.056.056.085l.028-.028Z" transform="translate(-3.217 -52.969)"/><path class="cls-1" d="M83.221,26.577c-.254-1.831-.732-3.634-1.042-5.493a6.982,6.982,0,0,1-.2-3.155c.394-1.352.2-1.408-1.07-2.084-.986-.535-1.972-1.042-2.9-1.606a1.116,1.116,0,0,1-.676-1.127c.084-.592-.282-.873-.732-1.042-1.211-.451-2.479-.845-3.69-1.324-.761-.31-1.69-.338-2.225-1.127-1.493-.423-2.648-1.549-4.366-1.606a4.048,4.048,0,0,1-3.774-2.028c-.253-.479-.732-.563-1.127-.761-.761-.366-1.521-.732-2.282-1.07C58.293,3.762,57.589,3.058,56.6,3c-.085.085-.2.169-.282.254.028-.113.028-.254.056-.366-.394-.366-.873-.958-1.38-.817-.817.254-1.352-.2-1.972-.479-.338-.141-.7-.254-1.042-.394-.507-.225-.789,0-1.183.338-.62.507-1.183.169-1.239-.676-.028-.254.169-.507.253-.761l-.056.085c-1.775-.056-1.8-.028-2.113,1.408A6.131,6.131,0,0,1,47.224,3.2a3.633,3.633,0,0,0-.2,1.634A.93.93,0,0,0,47.7,5.9c.366.113.732.2,1.07.31s.451.479.225.62c-.141.113-.338.282-.479.254-.648-.113-1.268-.338-1.887-.479a1.256,1.256,0,0,0-1.324.817A12.72,12.72,0,0,1,44.8,9.536c-.648,1.324-.169,2.253,1.1,2.986a4.2,4.2,0,0,0,1.042.394c3.155,1.155,6.309,2.253,9.436,3.493a22.964,22.964,0,0,1,4.957,2.563.651.651,0,0,1,.282.93.73.73,0,0,1-.93.423c-.986-.254-1.972-.507-2.958-.789a1.478,1.478,0,0,0-1.577.254.839.839,0,0,1-1.239.085,4.14,4.14,0,0,0-3.408-.958,1.369,1.369,0,0,1-.817-.141c-.873-.563-1.775-.282-2.676-.225-.648.056-1.3-.113-1.944-.085-.732.056-1.493-.338-2.169.225-.732.62-.958-.676-1.69-.423-.479.169-1.042-.085-1.549.394-.873.845-1.915.535-2.873.113a4.115,4.115,0,0,1-.93-.62.983.983,0,0,0-1.465.085,4.49,4.49,0,0,1-.592.423,3.093,3.093,0,0,0,1.8,1.493c.479.113.394.338-.282.761-.169.113-.2.028-.225-.028V21c0,.113.169.338.253.338a10.064,10.064,0,0,0,1.324-.113,3.622,3.622,0,0,1-.113-.535c.028-1.1.648-1.493,1.634-1.014.113.056.254.338.2.423a3.361,3.361,0,0,1-1.38,1.352c-.648.592-1.3,1.239-1.972,1.8a1.793,1.793,0,0,1-.986.394q-2.2.127-4.394.169a.348.348,0,0,1-.225-.113c-.056-.028-.085-.085-.141-.113-.535.141-1.1.254-1.634.394-.2-.169-.451-.338-.507-.563a1.947,1.947,0,0,0-2.422-1.352,5.378,5.378,0,0,1-2.225-.085c-.254-.085-.338-.169-.2-.338a.613.613,0,0,1,.225-.141,3.913,3.913,0,0,0,.535-.169,2.246,2.246,0,0,0,.451-.225c-.141-.113-.254-.282-.394-.31a3.02,3.02,0,0,0-1.1-.2c-2.366.282-4.732,1.07-7.126,0a.546.546,0,0,0-.507.085c-1.3.958-2.929.507-4.338.986-.113.225-.225.479-.507.225-.056-.028.085-.282.141-.423.169-.31.535-.676.479-.93-.141-.563-.7-.451-1.127-.366-.563.085-1.1.225-1.634.338a6.343,6.343,0,0,1-3.549.225,1.926,1.926,0,0,0-1.8.535c-.732.592-1.324.282-1.8-.366A2.842,2.842,0,0,0,.1,24.3a18.863,18.863,0,0,0,1.211,2.817c.113.225.535.338.366.62A1.05,1.05,0,0,0,2.1,29.365c.873.563-.535,1.662.507,2.253.056.028-.085.507-.225.732a5.039,5.039,0,0,1-.7.873c-.225.225-.282.479-.028.676a.535.535,0,0,0,.761-.028,1.628,1.628,0,0,1,2-.535c.394.169.366-.225.507-.451.507-.817.535-.817,1.3-.028.113.141.225.394.338.394a17.212,17.212,0,0,1,2.084.479,1.986,1.986,0,0,0,1.549-.535,10.2,10.2,0,0,1,1.155-.761c.789-.479.817-.451,1.577.592a1.079,1.079,0,0,0,.676.366c.31.028.394-.282.451-.535.282-1.07.394-1.127,1.211-.789.254.113.479.31.732.394.62.2,1.1.338,1.69-.31a3.631,3.631,0,0,1,3.127-.873c.9.113,1.831.31,2.732.366.789.056,1.437.141,1.831.986a1.376,1.376,0,0,0,.93.507c1.38.225,2.76.394,4.141.563a1.079,1.079,0,0,0,1.3-.789c.141-.423.535-.592.817-.169.451.676,1.211.845,1.831,1.239.451.31.93.648.958,1.3,0,.366.2.535.507.366s.563-.592.873-.648c1.042-.225.958-.958.986-1.718,0-.394.056-.761.563-.338a3.546,3.546,0,0,0,1.859.507l-.028.085a1.839,1.839,0,0,1,.423-.282c.028-.028.113.028.169.056.141.028.366.028.423.113.141.225,0,.366-.169.479.056.056.085.141.169.169.563.254.9.479.113.9a.494.494,0,0,0-.056.451c.056.141.31.31.394.254.479-.2.958-.423,1.437-.648a3.043,3.043,0,0,0,2.479.676,9.738,9.738,0,0,1,2.7-.2c.451.028.563-.535.254-1.042-.085-.141-.254-.225-.394-.366a2.353,2.353,0,0,1,2.9-.451c.7.31.676.648-.056,1.155a.618.618,0,0,0-.282.394.459.459,0,0,0,.31.366c.845.2,1.606-.056,1.831-.732.169-.507.113-1.268.62-1.437.732-.254.423,1.183,1.268,1.042l-.028.056c.282-.423.592-.761,1.127-.366h.225c.338,0,.761-.085.9.31.141.451-.31.535-.592.7-.085.056-.141.085-.225.141l.028-.056a23.339,23.339,0,0,0-2.535,7.07c-.141.62.338.986,1.014.817.958-.253.958-.253,1.183.394.056.169.084.366.141.535.394,1.127.479,1.183,1.577,1.211a4.128,4.128,0,0,0,2.873-.7,4.274,4.274,0,0,0,1.268-1.07c.507-.592,1.042.2,1.549-.085a5.684,5.684,0,0,0,1.211-.7,5.772,5.772,0,0,1,1.972-1.042A21.2,21.2,0,0,0,70.912,39.7a42.692,42.692,0,0,1,4.169-2.253,28.194,28.194,0,0,0,4-2.366C82.122,33.14,83.756,30.323,83.221,26.577ZM3.593,31.591s-.028-.141,0-.169c.028-.056.113-.085.169-.113C3.819,31.506,3.762,31.591,3.593,31.591Zm.873-.563a6.117,6.117,0,0,1-.676.2.479.479,0,0,1,.366-.563c.141-.028.31.085.451.141C4.579,30.886,4.551,31,4.466,31.027Zm17.1-9.267c.028.423-.7.451-1.127.479-.2,0-.394-.225-.563-.366a2.209,2.209,0,0,1,.676-.254C20.916,21.591,21.507,21.169,21.564,21.76Zm-1.887-.028c.028.028.056.056.056.085-.085-.028-.141-.056-.225-.085C19.564,21.732,19.648,21.7,19.677,21.732Zm-12.731.2c-.028-.338.31-.254.479-.338a2.5,2.5,0,0,1,.592-.169c.31-.056.676-.085,1.014-.169.2-.056.31,0,.423.2.085.141-.2.563-.394.676a2.112,2.112,0,0,1-1.606-.056C7.283,22.014,6.945,21.986,6.945,21.929ZM18.24,27.253a.421.421,0,0,1,.2-.085c.028,0,.113.113.113.113C18.381,27.422,18.268,27.422,18.24,27.253Zm7.605,2.028c-.282.113-.845-.169-.817-.394.028-.141.169-.338.282-.338a1.639,1.639,0,0,1,.732.085C26.183,28.661,26.042,29.2,25.845,29.281Zm.366,2.845c.028.028.056.028.056.056-.085,0-.141-.028-.225-.028C26.1,32.154,26.183,32.1,26.211,32.126Zm.282.169c.394-.056.789-.282,1.1.2A.773.773,0,0,1,26.493,32.295Zm1.239.423c-.056-.056-.056-.113-.085-.2.2-.056.31.028.282.2C27.929,32.717,27.76,32.745,27.732,32.717Zm3.436-.9.056-.141.085.141Zm5.07-5.971c-.817,1.042-.873,1.042-2.169.62-.282.056-.592.225-.817.169-2.141-.789-4.422-.085-6.563-.789a.781.781,0,0,0-.789.113,3.585,3.585,0,0,1-3.239.366,2.95,2.95,0,0,0-2.394.169c-.141.085-.507,0-.507-.056-.141-1.437-1.577-.451-2.141-1.155a.571.571,0,0,0-.507-.085c-.873,1.268-1.8.845-2.789.2-1.465.2-2.958.366-4.422.592a2.969,2.969,0,0,1-1.915-.141.3.3,0,0,1-.113-.169c.028-.085.113-.2.169-.2,2.479-.338,4.957-.761,7.464-.958a40.947,40.947,0,0,1,6.7-.254c1.042.085,2.253.056,2.873-.761.648-.845.789-.592,1.268.028a1.98,1.98,0,0,0,2.253.535.589.589,0,0,0,.169.113,10.126,10.126,0,0,0,3.324.028c1.014,0,1.972.535,3.042.2,1.07-.366,1.746.225,2.141,1.183A1.332,1.332,0,0,1,36.239,25.845Zm8.675-2.929c.028,0,.056.085.085.141a.421.421,0,0,1-.2.085c-.028,0-.056-.085-.085-.141A.6.6,0,0,1,44.914,22.915Zm-.958-2.789c.423-.2.676.056.873.394.028.056-.141.254-.225.394-.085,0-.2.056-.254,0-.225-.113-.451-.254-.676-.394C43.787,20.38,43.844,20.183,43.956,20.127Zm-5.267,4.028a.219.219,0,0,1,.225-.056,2.349,2.349,0,0,1,.338.225c-.113.028-.253.085-.366.113C38.633,24.464,38.548,24.352,38.689,24.155Zm1.1,1.972c-.225.028-.592-.028-.676-.2-.169-.282.141-.423.366-.507a5.355,5.355,0,0,1,.7-.085C40.154,25.676,40.238,26.07,39.788,26.126Zm.394-.845a1.814,1.814,0,0,1-.789-.93,3.078,3.078,0,0,1,.479-.141c.732-.113,1.127.028,1.1.423C40.914,25.084,40.548,25.2,40.182,25.281Zm-.225-1.944a.992.992,0,0,1-.479-.592.981.981,0,0,1,.338-.676.6.6,0,0,1,.507-.113c.282.028.62.113.676-.225.028-.169-.31-.366-.479-.592-.113-.141-.732.085-.366-.394.169-.225.394-.789.845-.507.507.31,1.324.366,1.268,1.268-.028.62.592.9.761,1.437a.939.939,0,0,1-.282.958C41.9,23.2,40.8,23.732,39.957,23.338ZM42.21,25.76c-.056.056-.169.028-.253.028-.028-.056-.113-.141-.085-.169.056-.056.113-.141.2-.141C42.323,25.478,42.379,25.591,42.21,25.76Zm0-1.211c.028-.113.028-.282.113-.338a1.067,1.067,0,0,1,.366-.169c.056.141.084.282.141.423a2.208,2.208,0,0,1-.394.141C42.379,24.633,42.295,24.577,42.21,24.549Zm.873,10.422c0-.056.028-.113.028-.169C43.252,34.858,43.224,34.886,43.083,34.971Zm.169-9.239a5.453,5.453,0,0,1-.31-1.211,1.2,1.2,0,0,1,1.1.563.9.9,0,0,1-.141.732A.382.382,0,0,1,43.252,25.732Zm1.606,8.112a3.235,3.235,0,0,1-.507.028c-.141-.056-.338-.2-.366-.338a.423.423,0,0,1,.423-.507,1.054,1.054,0,0,1,.507.141,1.415,1.415,0,0,1,.338.366C45.139,33.619,45,33.731,44.858,33.844Zm1.352,1.211.056-.141.084.141Zm.141-9.351c-.225.028-.338-.113-.2-.282a.851.851,0,0,1,.451-.141c.028,0,.084.113.141.141A.934.934,0,0,1,46.351,25.7Zm.056-5.155a.593.593,0,0,1,.676-.62,1.878,1.878,0,0,1,1.1.676,5.109,5.109,0,0,1-.676.676A.751.751,0,0,1,46.407,20.549Zm1.155,13.21c.085-.2.254-.2.338.028a1.486,1.486,0,0,1,.085.338c-.113-.056-.254-.085-.366-.141A.234.234,0,0,1,47.562,33.759Zm2.394-13.041c-.169-.028-.31-.056-.479-.085l.169-.338a3.376,3.376,0,0,0,.338.31c.085.056.2.141.282.2A1.27,1.27,0,0,1,49.956,20.718Zm2.648.225c-.31.225-.845-.169-.93-.648-.056-.366.253-.761.563-.732s.592.338.676.817C52.829,20.521,52.773,20.831,52.6,20.944Z" transform="translate(0.056 -0.1)"/><path d="M123.4,66.013c.028-.028.056-.028.085-.056,0-.028-.028-.028-.028-.056Z" transform="translate(-88.626 -47.366)"/><path d="M107.4,83.2l.056.056h.028Z" transform="translate(-77.133 -59.793)"/><path d="M128.3,73.817c.028-.056,0-.028,0,0Z" transform="translate(-92.146 -53.03)"/></g></svg></a>',
    customPaging : function(slider, i) {
        var thumb = $(slider.$slides[i]).data('thumb');
        return '<div class="home-custom-pager"></div>';
    },
    autoplay: false,
    autoplaySpeed: 5000,
  });

  $('.values-slider').slick({
    fade: true,
    dots: true,
    nextArrow:'<a href="#" class="arrow-right"><svg class="icon-slide-nav-right" viewBox="-9322 -18028 83.377 45.158"><defs><style>.icon-slide-nav-right {width:83.38px;height:45.16px;}.icon-slide-nav-right .cls-1 {fill:#fff;}</style></defs><g transform="translate(-9322 -18028)"><path d="M144.913,118.056c-.028,0-.056-.028-.085-.056H144.8Z" transform="translate(-103.999 -84.791)"/><path d="M145.4,120.085c.028-.028.056-.028.085-.056a.028.028,0,0,0-.028-.028Z" transform="translate(-104.43 -86.228)"/><path d="M197.885,121.328c-.028,0-.028-.028-.056-.028H197.8Z" transform="translate(-142.07 -87.162)"/><path d="M4.5,73.7c.028.028.028.056.056.085l.028-.028Z" transform="translate(-3.217 -52.969)"/><path class="cls-1" d="M83.221,26.577c-.254-1.831-.732-3.634-1.042-5.493a6.982,6.982,0,0,1-.2-3.155c.394-1.352.2-1.408-1.07-2.084-.986-.535-1.972-1.042-2.9-1.606a1.116,1.116,0,0,1-.676-1.127c.084-.592-.282-.873-.732-1.042-1.211-.451-2.479-.845-3.69-1.324-.761-.31-1.69-.338-2.225-1.127-1.493-.423-2.648-1.549-4.366-1.606a4.048,4.048,0,0,1-3.774-2.028c-.253-.479-.732-.563-1.127-.761-.761-.366-1.521-.732-2.282-1.07C58.293,3.762,57.589,3.058,56.6,3c-.085.085-.2.169-.282.254.028-.113.028-.254.056-.366-.394-.366-.873-.958-1.38-.817-.817.254-1.352-.2-1.972-.479-.338-.141-.7-.254-1.042-.394-.507-.225-.789,0-1.183.338-.62.507-1.183.169-1.239-.676-.028-.254.169-.507.253-.761l-.056.085c-1.775-.056-1.8-.028-2.113,1.408A6.131,6.131,0,0,1,47.224,3.2a3.633,3.633,0,0,0-.2,1.634A.93.93,0,0,0,47.7,5.9c.366.113.732.2,1.07.31s.451.479.225.62c-.141.113-.338.282-.479.254-.648-.113-1.268-.338-1.887-.479a1.256,1.256,0,0,0-1.324.817A12.72,12.72,0,0,1,44.8,9.536c-.648,1.324-.169,2.253,1.1,2.986a4.2,4.2,0,0,0,1.042.394c3.155,1.155,6.309,2.253,9.436,3.493a22.964,22.964,0,0,1,4.957,2.563.651.651,0,0,1,.282.93.73.73,0,0,1-.93.423c-.986-.254-1.972-.507-2.958-.789a1.478,1.478,0,0,0-1.577.254.839.839,0,0,1-1.239.085,4.14,4.14,0,0,0-3.408-.958,1.369,1.369,0,0,1-.817-.141c-.873-.563-1.775-.282-2.676-.225-.648.056-1.3-.113-1.944-.085-.732.056-1.493-.338-2.169.225-.732.62-.958-.676-1.69-.423-.479.169-1.042-.085-1.549.394-.873.845-1.915.535-2.873.113a4.115,4.115,0,0,1-.93-.62.983.983,0,0,0-1.465.085,4.49,4.49,0,0,1-.592.423,3.093,3.093,0,0,0,1.8,1.493c.479.113.394.338-.282.761-.169.113-.2.028-.225-.028V21c0,.113.169.338.253.338a10.064,10.064,0,0,0,1.324-.113,3.622,3.622,0,0,1-.113-.535c.028-1.1.648-1.493,1.634-1.014.113.056.254.338.2.423a3.361,3.361,0,0,1-1.38,1.352c-.648.592-1.3,1.239-1.972,1.8a1.793,1.793,0,0,1-.986.394q-2.2.127-4.394.169a.348.348,0,0,1-.225-.113c-.056-.028-.085-.085-.141-.113-.535.141-1.1.254-1.634.394-.2-.169-.451-.338-.507-.563a1.947,1.947,0,0,0-2.422-1.352,5.378,5.378,0,0,1-2.225-.085c-.254-.085-.338-.169-.2-.338a.613.613,0,0,1,.225-.141,3.913,3.913,0,0,0,.535-.169,2.246,2.246,0,0,0,.451-.225c-.141-.113-.254-.282-.394-.31a3.02,3.02,0,0,0-1.1-.2c-2.366.282-4.732,1.07-7.126,0a.546.546,0,0,0-.507.085c-1.3.958-2.929.507-4.338.986-.113.225-.225.479-.507.225-.056-.028.085-.282.141-.423.169-.31.535-.676.479-.93-.141-.563-.7-.451-1.127-.366-.563.085-1.1.225-1.634.338a6.343,6.343,0,0,1-3.549.225,1.926,1.926,0,0,0-1.8.535c-.732.592-1.324.282-1.8-.366A2.842,2.842,0,0,0,.1,24.3a18.863,18.863,0,0,0,1.211,2.817c.113.225.535.338.366.62A1.05,1.05,0,0,0,2.1,29.365c.873.563-.535,1.662.507,2.253.056.028-.085.507-.225.732a5.039,5.039,0,0,1-.7.873c-.225.225-.282.479-.028.676a.535.535,0,0,0,.761-.028,1.628,1.628,0,0,1,2-.535c.394.169.366-.225.507-.451.507-.817.535-.817,1.3-.028.113.141.225.394.338.394a17.212,17.212,0,0,1,2.084.479,1.986,1.986,0,0,0,1.549-.535,10.2,10.2,0,0,1,1.155-.761c.789-.479.817-.451,1.577.592a1.079,1.079,0,0,0,.676.366c.31.028.394-.282.451-.535.282-1.07.394-1.127,1.211-.789.254.113.479.31.732.394.62.2,1.1.338,1.69-.31a3.631,3.631,0,0,1,3.127-.873c.9.113,1.831.31,2.732.366.789.056,1.437.141,1.831.986a1.376,1.376,0,0,0,.93.507c1.38.225,2.76.394,4.141.563a1.079,1.079,0,0,0,1.3-.789c.141-.423.535-.592.817-.169.451.676,1.211.845,1.831,1.239.451.31.93.648.958,1.3,0,.366.2.535.507.366s.563-.592.873-.648c1.042-.225.958-.958.986-1.718,0-.394.056-.761.563-.338a3.546,3.546,0,0,0,1.859.507l-.028.085a1.839,1.839,0,0,1,.423-.282c.028-.028.113.028.169.056.141.028.366.028.423.113.141.225,0,.366-.169.479.056.056.085.141.169.169.563.254.9.479.113.9a.494.494,0,0,0-.056.451c.056.141.31.31.394.254.479-.2.958-.423,1.437-.648a3.043,3.043,0,0,0,2.479.676,9.738,9.738,0,0,1,2.7-.2c.451.028.563-.535.254-1.042-.085-.141-.254-.225-.394-.366a2.353,2.353,0,0,1,2.9-.451c.7.31.676.648-.056,1.155a.618.618,0,0,0-.282.394.459.459,0,0,0,.31.366c.845.2,1.606-.056,1.831-.732.169-.507.113-1.268.62-1.437.732-.254.423,1.183,1.268,1.042l-.028.056c.282-.423.592-.761,1.127-.366h.225c.338,0,.761-.085.9.31.141.451-.31.535-.592.7-.085.056-.141.085-.225.141l.028-.056a23.339,23.339,0,0,0-2.535,7.07c-.141.62.338.986,1.014.817.958-.253.958-.253,1.183.394.056.169.084.366.141.535.394,1.127.479,1.183,1.577,1.211a4.128,4.128,0,0,0,2.873-.7,4.274,4.274,0,0,0,1.268-1.07c.507-.592,1.042.2,1.549-.085a5.684,5.684,0,0,0,1.211-.7,5.772,5.772,0,0,1,1.972-1.042A21.2,21.2,0,0,0,70.912,39.7a42.692,42.692,0,0,1,4.169-2.253,28.194,28.194,0,0,0,4-2.366C82.122,33.14,83.756,30.323,83.221,26.577ZM3.593,31.591s-.028-.141,0-.169c.028-.056.113-.085.169-.113C3.819,31.506,3.762,31.591,3.593,31.591Zm.873-.563a6.117,6.117,0,0,1-.676.2.479.479,0,0,1,.366-.563c.141-.028.31.085.451.141C4.579,30.886,4.551,31,4.466,31.027Zm17.1-9.267c.028.423-.7.451-1.127.479-.2,0-.394-.225-.563-.366a2.209,2.209,0,0,1,.676-.254C20.916,21.591,21.507,21.169,21.564,21.76Zm-1.887-.028c.028.028.056.056.056.085-.085-.028-.141-.056-.225-.085C19.564,21.732,19.648,21.7,19.677,21.732Zm-12.731.2c-.028-.338.31-.254.479-.338a2.5,2.5,0,0,1,.592-.169c.31-.056.676-.085,1.014-.169.2-.056.31,0,.423.2.085.141-.2.563-.394.676a2.112,2.112,0,0,1-1.606-.056C7.283,22.014,6.945,21.986,6.945,21.929ZM18.24,27.253a.421.421,0,0,1,.2-.085c.028,0,.113.113.113.113C18.381,27.422,18.268,27.422,18.24,27.253Zm7.605,2.028c-.282.113-.845-.169-.817-.394.028-.141.169-.338.282-.338a1.639,1.639,0,0,1,.732.085C26.183,28.661,26.042,29.2,25.845,29.281Zm.366,2.845c.028.028.056.028.056.056-.085,0-.141-.028-.225-.028C26.1,32.154,26.183,32.1,26.211,32.126Zm.282.169c.394-.056.789-.282,1.1.2A.773.773,0,0,1,26.493,32.295Zm1.239.423c-.056-.056-.056-.113-.085-.2.2-.056.31.028.282.2C27.929,32.717,27.76,32.745,27.732,32.717Zm3.436-.9.056-.141.085.141Zm5.07-5.971c-.817,1.042-.873,1.042-2.169.62-.282.056-.592.225-.817.169-2.141-.789-4.422-.085-6.563-.789a.781.781,0,0,0-.789.113,3.585,3.585,0,0,1-3.239.366,2.95,2.95,0,0,0-2.394.169c-.141.085-.507,0-.507-.056-.141-1.437-1.577-.451-2.141-1.155a.571.571,0,0,0-.507-.085c-.873,1.268-1.8.845-2.789.2-1.465.2-2.958.366-4.422.592a2.969,2.969,0,0,1-1.915-.141.3.3,0,0,1-.113-.169c.028-.085.113-.2.169-.2,2.479-.338,4.957-.761,7.464-.958a40.947,40.947,0,0,1,6.7-.254c1.042.085,2.253.056,2.873-.761.648-.845.789-.592,1.268.028a1.98,1.98,0,0,0,2.253.535.589.589,0,0,0,.169.113,10.126,10.126,0,0,0,3.324.028c1.014,0,1.972.535,3.042.2,1.07-.366,1.746.225,2.141,1.183A1.332,1.332,0,0,1,36.239,25.845Zm8.675-2.929c.028,0,.056.085.085.141a.421.421,0,0,1-.2.085c-.028,0-.056-.085-.085-.141A.6.6,0,0,1,44.914,22.915Zm-.958-2.789c.423-.2.676.056.873.394.028.056-.141.254-.225.394-.085,0-.2.056-.254,0-.225-.113-.451-.254-.676-.394C43.787,20.38,43.844,20.183,43.956,20.127Zm-5.267,4.028a.219.219,0,0,1,.225-.056,2.349,2.349,0,0,1,.338.225c-.113.028-.253.085-.366.113C38.633,24.464,38.548,24.352,38.689,24.155Zm1.1,1.972c-.225.028-.592-.028-.676-.2-.169-.282.141-.423.366-.507a5.355,5.355,0,0,1,.7-.085C40.154,25.676,40.238,26.07,39.788,26.126Zm.394-.845a1.814,1.814,0,0,1-.789-.93,3.078,3.078,0,0,1,.479-.141c.732-.113,1.127.028,1.1.423C40.914,25.084,40.548,25.2,40.182,25.281Zm-.225-1.944a.992.992,0,0,1-.479-.592.981.981,0,0,1,.338-.676.6.6,0,0,1,.507-.113c.282.028.62.113.676-.225.028-.169-.31-.366-.479-.592-.113-.141-.732.085-.366-.394.169-.225.394-.789.845-.507.507.31,1.324.366,1.268,1.268-.028.62.592.9.761,1.437a.939.939,0,0,1-.282.958C41.9,23.2,40.8,23.732,39.957,23.338ZM42.21,25.76c-.056.056-.169.028-.253.028-.028-.056-.113-.141-.085-.169.056-.056.113-.141.2-.141C42.323,25.478,42.379,25.591,42.21,25.76Zm0-1.211c.028-.113.028-.282.113-.338a1.067,1.067,0,0,1,.366-.169c.056.141.084.282.141.423a2.208,2.208,0,0,1-.394.141C42.379,24.633,42.295,24.577,42.21,24.549Zm.873,10.422c0-.056.028-.113.028-.169C43.252,34.858,43.224,34.886,43.083,34.971Zm.169-9.239a5.453,5.453,0,0,1-.31-1.211,1.2,1.2,0,0,1,1.1.563.9.9,0,0,1-.141.732A.382.382,0,0,1,43.252,25.732Zm1.606,8.112a3.235,3.235,0,0,1-.507.028c-.141-.056-.338-.2-.366-.338a.423.423,0,0,1,.423-.507,1.054,1.054,0,0,1,.507.141,1.415,1.415,0,0,1,.338.366C45.139,33.619,45,33.731,44.858,33.844Zm1.352,1.211.056-.141.084.141Zm.141-9.351c-.225.028-.338-.113-.2-.282a.851.851,0,0,1,.451-.141c.028,0,.084.113.141.141A.934.934,0,0,1,46.351,25.7Zm.056-5.155a.593.593,0,0,1,.676-.62,1.878,1.878,0,0,1,1.1.676,5.109,5.109,0,0,1-.676.676A.751.751,0,0,1,46.407,20.549Zm1.155,13.21c.085-.2.254-.2.338.028a1.486,1.486,0,0,1,.085.338c-.113-.056-.254-.085-.366-.141A.234.234,0,0,1,47.562,33.759Zm2.394-13.041c-.169-.028-.31-.056-.479-.085l.169-.338a3.376,3.376,0,0,0,.338.31c.085.056.2.141.282.2A1.27,1.27,0,0,1,49.956,20.718Zm2.648.225c-.31.225-.845-.169-.93-.648-.056-.366.253-.761.563-.732s.592.338.676.817C52.829,20.521,52.773,20.831,52.6,20.944Z" transform="translate(0.056 -0.1)"/><path d="M123.4,66.013c.028-.028.056-.028.085-.056,0-.028-.028-.028-.028-.056Z" transform="translate(-88.626 -47.366)"/><path d="M107.4,83.2l.056.056h.028Z" transform="translate(-77.133 -59.793)"/><path d="M128.3,73.817c.028-.056,0-.028,0,0Z" transform="translate(-92.146 -53.03)"/></g></svg></a>',
    customPaging : function(slider, i) {
        var thumb = $(slider.$slides[i]).data('thumb');
        return '<div class="home-custom-pager"></div>';
    },
    autoplaySpeed: 5000,
  });


  $('#item-slider').slick({
    fade: true,
    dots: true,
    prevArrow: '<a href="#" class="arrow-left"><svg class="icon-slide-nav-left" viewBox="-11091 -18027 99.684 42.066"><defs><style>.icon-slide-nav-left {width:99.68px;} .icon-slide-nav-left .cls-1{fill:#fff;}</style></defs><g transform="translate(-11091 -18027)"><path d="M201.484,77.2c-.028.028-.056.028-.085.056a.028.028,0,0,1,.028.028Z" transform="translate(-144.69 -55.559)"/><path class="cls-1" d="M98.826,16.178a16.92,16.92,0,0,1-2.282-2.648.028.028,0,0,1,.028-.028c-.2-.479-.592-.817-1.07-.648a11.845,11.845,0,0,1-4.112.254c-1.634-.028-3.408-.169-4.619,1.408-1.183.479-2.31,1.324-3.634.282-.338-.254-.7.085-1.014.2a4.755,4.755,0,0,1-3.774-.169,7.748,7.748,0,0,0-5.155-.451c-.845.2-1.718.028-2.451.282a3.313,3.313,0,0,1-2.676.113c-.958-.592-1.606.254-2.394.085a.849.849,0,0,1-.479-.225,1.687,1.687,0,0,1-.282-.7c0-.085.253-.282.394-.31.423-.085.873-.141,1.324-.2a.539.539,0,0,0-.479-.479A26.456,26.456,0,0,1,61,11.953a1.72,1.72,0,0,0-1.324.282.888.888,0,0,1-1.042,0,1.563,1.563,0,0,1-.169-.225c-.282-.507-.7-.7-1.1-.282-1.07,1.1-2.028,1.07-3.127.028a1.774,1.774,0,0,0-1.859-.225,1.963,1.963,0,0,1-2.253-.282c-.338-.31-.873-.169-1.324.056-.31.169-.732.394-1.014.31a3.336,3.336,0,0,0-2.451.113c-.789.394-1.69-.282-2.394.31-.7-.479-1.465.282-2.056,0a4.417,4.417,0,0,0-3.774.225,3.177,3.177,0,0,1-1.352.141c-.732-.056-1.549-.732-2.141-.056-.9.958-1.493.028-2.225-.113-.225-.056-.507.2-.732.31a2.529,2.529,0,0,1-1.634.254c-.451-.085-1.155-.113-1.268-.366-.282-.62.423-.9.845-1.239.7-.62,1.408-1.211,2.113-1.859a12.556,12.556,0,0,0,2.76-3.549,2.992,2.992,0,0,0-1.69-4.507c-.648-.225-1.042-.845-1.69-.9-.732-.056-1.493.169-2.225.141a2.591,2.591,0,0,0-1.3.394,37.619,37.619,0,0,0-5.408,2.76.958.958,0,0,1-.761.141c-.423-.254-.62-.225-.845.225-.225.507-.141,1.127-.648,1.521a.541.541,0,0,1-.789-.282c-.282-.563-.732-.789-1.127-.563-.563.31-.761,1.239-1.521,1.07a3.678,3.678,0,0,0-2.394.507c-1.493.563-2.9,1.3-4.366,1.8A4.5,4.5,0,0,0,6.185,9.7c-.62.9-1.8.93-2.563,1.634a1.562,1.562,0,0,0-.169.225C2.073,13.784.693,16.009.777,18.8a14.975,14.975,0,0,1-.451,3.324c-.2.93-.676,1.8.507,2.451.31.169.113.507,0,.761a3.163,3.163,0,0,0-.394,1.042c0,.648.7.423,1.042.676.282.225.62.423.9.648a10.71,10.71,0,0,0,4.366,2.394,6.242,6.242,0,0,1,2.31.986,38.113,38.113,0,0,0,5.155,2.845c3.127,1.465,6.14,3.183,9.211,4.788.648.338,1.437.535,1.38,1.549-.028.225.225.282.423.141.789-.592,1.155-.254,1.352.592.085.366.394.282.62.085.592-.507.986-.31,1.324.31a5.451,5.451,0,0,0,.648.761l-.028.028c.31.254.62.423.93,0,.113-.141.056-.366.141-.535.394-.732.9-1.38,1.268-2.169.451-1.042-.648-1.746-.338-2.676a.976.976,0,0,0-.535-1.155c-1.183-.7-2.394-1.38-3.634-2A19.533,19.533,0,0,1,21.4,30.037a6.289,6.289,0,0,0-2.338-1.493,2.973,2.973,0,0,1-1.972-1.831c-.2-.592-.817-.648-1.239-.958h0c.254-.282-.366-.113-.028-.282a4.848,4.848,0,0,1,2.873-.423,8.143,8.143,0,0,0,1.634.225c2.62-.113,5.155.7,7.774.479,2.084.648,4.253.254,6.366.676a4.657,4.657,0,0,0,2.141-.225c.253-.056.423-.535.62-.845.282.254.535.507.817.732a1.6,1.6,0,0,0,1.324.254,6.4,6.4,0,0,1,2.2.028,33.772,33.772,0,0,0,4.141.394c.338.028,1.014-.113,1.014-.225.028-.648-.563-.507-.958-.592-.732-.113-.423-.676-.479-1.07-.084-.592-.338-.676-.873-.338-1.014.648-1.324.507-1.577-.789a.766.766,0,0,1,0-.254c.479-.225,1.014-.676,1.465-.648,1.1.113,2.2-.028,3.239.085,2.507.282,4.986-.085,7.436,0,.873.028,1.268-.507,1.8-.873A3.287,3.287,0,0,0,54.66,21.5c-.563.028-1.127.085-1.69.085a7.7,7.7,0,0,1-1.38-.169c-.254-.056-.535-.169-.394-.507a.555.555,0,0,1,.423-.282,38.6,38.6,0,0,0,4.422.028c1.718-.225,3.521.7,5.155-.451.2-.141.535-.028.817,0,1.211.028,2.422.113,3.634.085,2.789-.085,5.605.366,8.366-.282,1.437-.338,2.76.282,4.169.366.113,0,.225.169.366.254-.169.085-.31.282-.479.254-1.944-.141-3.887.366-5.859.225-1.465-.085-2.929.423-4.422.338-.254,0-.451.338-.423.648.028.169.113.394.253.451a6.6,6.6,0,0,0,2.451.423c1.634.028,3.3.169,4.929.254a.691.691,0,0,1,.7.676,1.442,1.442,0,0,0,.225.789c.282.366.648.113,1.014.028.254-.056.62-.085.761.056.7.732,1.211.62,1.775-.2a.87.87,0,0,1,1.408-.028,4.337,4.337,0,0,1,.423.986c.141.31.535.338.62.113.366-.986,1.239-.845,2-1.1.732-.225,1.127-.282,1.69.31.423.451.9.2,1.3-.451.141-.225.225-.563.423-.648a1.043,1.043,0,0,1,.817.056c.338.169.563.479.9.648.225.113.62.282.761.169,1.211-.873,2.7-.7,4.028-1.1a8.989,8.989,0,0,0,5.352-4.2A2.081,2.081,0,0,0,98.826,16.178ZM9.537,9.475l-.056-.141h.141ZM29.282,41.5c.028.085.141.169.113.2l-.254.338A.394.394,0,0,1,29.282,41.5ZM23.93,24.009l-.141-.141a.505.505,0,0,1,.2-.141c.085.028.141.028.225.056C24.1,23.868,24.015,23.953,23.93,24.009Zm7.211.986c-.056.028-.169-.028-.254-.028,0-.056-.028-.169,0-.2a.284.284,0,0,1,.254-.085C31.394,24.741,31.423,24.882,31.141,24.995Zm1.887.084c-.084.225-.563.169-.732-.056a.98.98,0,0,1-.225-1.014c.169-.423.592-.451.958-.451.141,0,.282.2.394.282C33.282,24.234,33.2,24.685,33.028,25.079Zm2.986-.592c-.056.451.141,1.014-.535,1.014-.507,0-.761-.479-.9-.93a1.512,1.512,0,0,1,.31-1.324c.085-.141.31-.2.479-.282.169.056.366.085.451.2A1.907,1.907,0,0,1,36.014,24.488Zm2.169-3.155a.285.285,0,0,1-.282-.394.9.9,0,0,1,.254-.423,1.584,1.584,0,0,1,.507-.2,5.042,5.042,0,0,1,2.422.254c.056,0,.085.141.085.2a.348.348,0,0,1-.113.225c-.141.113-.282.282-.451.31C39.816,21.333,39,21.333,38.183,21.333Zm1.1,2.141c-.253.028-.31-.085-.2-.254a.219.219,0,0,1,.225-.056c.056,0,.085.085.141.141C39.394,23.389,39.337,23.474,39.281,23.474Zm.93,2.225c-.056.056-.479-.225-.592-.423-.141-.282-.479-.732-.085-.986a16.076,16.076,0,0,1,2.394-1.239c.366-.169.676.141.873.507h0C42.408,24.8,41.112,25.051,40.211,25.7Zm7.408-4.028a.772.772,0,0,1-.958.338,5.217,5.217,0,0,1-.93-.592c-.141-.113-.282-.31-.253-.451s.253-.254.394-.338a.379.379,0,0,1,.225-.056,4.814,4.814,0,0,1,.873-.085c.394,0,.789.113.9.507C47.928,21.164,47.759,21.474,47.618,21.671Zm.563-8.76c-.056-.056-.2-.113-.2-.169a.453.453,0,0,1,.451-.535.251.251,0,0,1,.225.141C48.773,12.545,48.407,12.939,48.182,12.911Zm5.3,3.521a2.208,2.208,0,0,0-.141.394C53.055,16.488,53.252,16.46,53.477,16.432Zm1.859,2.7a1.356,1.356,0,0,1-1.3.338c-.056-.028-.113-.113-.169-.169a.487.487,0,0,1,.028-.282.981.981,0,0,1,1.408-.366A.428.428,0,0,1,55.336,19.136Zm.31-2.394a.709.709,0,0,1-.845.394c-.2-.028-.225-.225-.056-.366.2-.169.423-.282.62-.423a1.562,1.562,0,0,1,.225.169A.234.234,0,0,1,55.646,16.742Zm1.38-2.451a.814.814,0,0,1-.62.366c-.169-.028-.394-.366-.423-.592s.084-.563.394-.507C56.857,13.643,57.2,14.038,57.026,14.291Zm1.352,5.521a4.329,4.329,0,0,1-.479-.535s.085-.169.169-.169c.338-.085.479.085.563.394C58.547,19.615,58.463,19.7,58.378,19.812Zm3.465-2.2a2.578,2.578,0,0,1-.451-.028c.056-.113.113-.338.169-.338.141,0,.282.113.451.169C61.955,17.5,61.9,17.615,61.843,17.615Zm1.408-1.465a3.047,3.047,0,0,1-.507,0c.056-.31.338-.225.507-.254.056,0,.141.085.225.113C63.392,16.038,63.336,16.15,63.251,16.15ZM73,16.685a1.3,1.3,0,0,1-.789-.084c-.085-.028-.169-.31-.113-.451.113-.338.423-.338.7-.282a4.3,4.3,0,0,1,.7.254C73.335,16.319,73.222,16.6,73,16.685Zm5.774,6.845a.634.634,0,0,1-.141-.141.505.505,0,0,1,.2-.141c.084.028.141.028.225.056C78.968,23.361,78.884,23.446,78.771,23.53Zm3.38-2.845c-.141.028-.31-.085-.479-.141.141-.085.282-.169.451-.282.169.056.31.113.479.169C82.461,20.516,82.32,20.685,82.151,20.685Z" transform="translate(-0.062 -0.368)"/><path d="M236.456,46.5H236.4v.084Z" transform="translate(-169.831 -33.506)"/></g></svg></a>',
    nextArrow:'<a href="#" class="arrow-right"><svg class="icon-slide-nav-right" viewBox="-9322 -18028 83.377 45.158"><defs><style>.icon-slide-nav-right {width:83.38px;height:45.16px;}.icon-slide-nav-right .cls-1 {fill:#fff;}</style></defs><g transform="translate(-9322 -18028)"><path d="M144.913,118.056c-.028,0-.056-.028-.085-.056H144.8Z" transform="translate(-103.999 -84.791)"/><path d="M145.4,120.085c.028-.028.056-.028.085-.056a.028.028,0,0,0-.028-.028Z" transform="translate(-104.43 -86.228)"/><path d="M197.885,121.328c-.028,0-.028-.028-.056-.028H197.8Z" transform="translate(-142.07 -87.162)"/><path d="M4.5,73.7c.028.028.028.056.056.085l.028-.028Z" transform="translate(-3.217 -52.969)"/><path class="cls-1" d="M83.221,26.577c-.254-1.831-.732-3.634-1.042-5.493a6.982,6.982,0,0,1-.2-3.155c.394-1.352.2-1.408-1.07-2.084-.986-.535-1.972-1.042-2.9-1.606a1.116,1.116,0,0,1-.676-1.127c.084-.592-.282-.873-.732-1.042-1.211-.451-2.479-.845-3.69-1.324-.761-.31-1.69-.338-2.225-1.127-1.493-.423-2.648-1.549-4.366-1.606a4.048,4.048,0,0,1-3.774-2.028c-.253-.479-.732-.563-1.127-.761-.761-.366-1.521-.732-2.282-1.07C58.293,3.762,57.589,3.058,56.6,3c-.085.085-.2.169-.282.254.028-.113.028-.254.056-.366-.394-.366-.873-.958-1.38-.817-.817.254-1.352-.2-1.972-.479-.338-.141-.7-.254-1.042-.394-.507-.225-.789,0-1.183.338-.62.507-1.183.169-1.239-.676-.028-.254.169-.507.253-.761l-.056.085c-1.775-.056-1.8-.028-2.113,1.408A6.131,6.131,0,0,1,47.224,3.2a3.633,3.633,0,0,0-.2,1.634A.93.93,0,0,0,47.7,5.9c.366.113.732.2,1.07.31s.451.479.225.62c-.141.113-.338.282-.479.254-.648-.113-1.268-.338-1.887-.479a1.256,1.256,0,0,0-1.324.817A12.72,12.72,0,0,1,44.8,9.536c-.648,1.324-.169,2.253,1.1,2.986a4.2,4.2,0,0,0,1.042.394c3.155,1.155,6.309,2.253,9.436,3.493a22.964,22.964,0,0,1,4.957,2.563.651.651,0,0,1,.282.93.73.73,0,0,1-.93.423c-.986-.254-1.972-.507-2.958-.789a1.478,1.478,0,0,0-1.577.254.839.839,0,0,1-1.239.085,4.14,4.14,0,0,0-3.408-.958,1.369,1.369,0,0,1-.817-.141c-.873-.563-1.775-.282-2.676-.225-.648.056-1.3-.113-1.944-.085-.732.056-1.493-.338-2.169.225-.732.62-.958-.676-1.69-.423-.479.169-1.042-.085-1.549.394-.873.845-1.915.535-2.873.113a4.115,4.115,0,0,1-.93-.62.983.983,0,0,0-1.465.085,4.49,4.49,0,0,1-.592.423,3.093,3.093,0,0,0,1.8,1.493c.479.113.394.338-.282.761-.169.113-.2.028-.225-.028V21c0,.113.169.338.253.338a10.064,10.064,0,0,0,1.324-.113,3.622,3.622,0,0,1-.113-.535c.028-1.1.648-1.493,1.634-1.014.113.056.254.338.2.423a3.361,3.361,0,0,1-1.38,1.352c-.648.592-1.3,1.239-1.972,1.8a1.793,1.793,0,0,1-.986.394q-2.2.127-4.394.169a.348.348,0,0,1-.225-.113c-.056-.028-.085-.085-.141-.113-.535.141-1.1.254-1.634.394-.2-.169-.451-.338-.507-.563a1.947,1.947,0,0,0-2.422-1.352,5.378,5.378,0,0,1-2.225-.085c-.254-.085-.338-.169-.2-.338a.613.613,0,0,1,.225-.141,3.913,3.913,0,0,0,.535-.169,2.246,2.246,0,0,0,.451-.225c-.141-.113-.254-.282-.394-.31a3.02,3.02,0,0,0-1.1-.2c-2.366.282-4.732,1.07-7.126,0a.546.546,0,0,0-.507.085c-1.3.958-2.929.507-4.338.986-.113.225-.225.479-.507.225-.056-.028.085-.282.141-.423.169-.31.535-.676.479-.93-.141-.563-.7-.451-1.127-.366-.563.085-1.1.225-1.634.338a6.343,6.343,0,0,1-3.549.225,1.926,1.926,0,0,0-1.8.535c-.732.592-1.324.282-1.8-.366A2.842,2.842,0,0,0,.1,24.3a18.863,18.863,0,0,0,1.211,2.817c.113.225.535.338.366.62A1.05,1.05,0,0,0,2.1,29.365c.873.563-.535,1.662.507,2.253.056.028-.085.507-.225.732a5.039,5.039,0,0,1-.7.873c-.225.225-.282.479-.028.676a.535.535,0,0,0,.761-.028,1.628,1.628,0,0,1,2-.535c.394.169.366-.225.507-.451.507-.817.535-.817,1.3-.028.113.141.225.394.338.394a17.212,17.212,0,0,1,2.084.479,1.986,1.986,0,0,0,1.549-.535,10.2,10.2,0,0,1,1.155-.761c.789-.479.817-.451,1.577.592a1.079,1.079,0,0,0,.676.366c.31.028.394-.282.451-.535.282-1.07.394-1.127,1.211-.789.254.113.479.31.732.394.62.2,1.1.338,1.69-.31a3.631,3.631,0,0,1,3.127-.873c.9.113,1.831.31,2.732.366.789.056,1.437.141,1.831.986a1.376,1.376,0,0,0,.93.507c1.38.225,2.76.394,4.141.563a1.079,1.079,0,0,0,1.3-.789c.141-.423.535-.592.817-.169.451.676,1.211.845,1.831,1.239.451.31.93.648.958,1.3,0,.366.2.535.507.366s.563-.592.873-.648c1.042-.225.958-.958.986-1.718,0-.394.056-.761.563-.338a3.546,3.546,0,0,0,1.859.507l-.028.085a1.839,1.839,0,0,1,.423-.282c.028-.028.113.028.169.056.141.028.366.028.423.113.141.225,0,.366-.169.479.056.056.085.141.169.169.563.254.9.479.113.9a.494.494,0,0,0-.056.451c.056.141.31.31.394.254.479-.2.958-.423,1.437-.648a3.043,3.043,0,0,0,2.479.676,9.738,9.738,0,0,1,2.7-.2c.451.028.563-.535.254-1.042-.085-.141-.254-.225-.394-.366a2.353,2.353,0,0,1,2.9-.451c.7.31.676.648-.056,1.155a.618.618,0,0,0-.282.394.459.459,0,0,0,.31.366c.845.2,1.606-.056,1.831-.732.169-.507.113-1.268.62-1.437.732-.254.423,1.183,1.268,1.042l-.028.056c.282-.423.592-.761,1.127-.366h.225c.338,0,.761-.085.9.31.141.451-.31.535-.592.7-.085.056-.141.085-.225.141l.028-.056a23.339,23.339,0,0,0-2.535,7.07c-.141.62.338.986,1.014.817.958-.253.958-.253,1.183.394.056.169.084.366.141.535.394,1.127.479,1.183,1.577,1.211a4.128,4.128,0,0,0,2.873-.7,4.274,4.274,0,0,0,1.268-1.07c.507-.592,1.042.2,1.549-.085a5.684,5.684,0,0,0,1.211-.7,5.772,5.772,0,0,1,1.972-1.042A21.2,21.2,0,0,0,70.912,39.7a42.692,42.692,0,0,1,4.169-2.253,28.194,28.194,0,0,0,4-2.366C82.122,33.14,83.756,30.323,83.221,26.577ZM3.593,31.591s-.028-.141,0-.169c.028-.056.113-.085.169-.113C3.819,31.506,3.762,31.591,3.593,31.591Zm.873-.563a6.117,6.117,0,0,1-.676.2.479.479,0,0,1,.366-.563c.141-.028.31.085.451.141C4.579,30.886,4.551,31,4.466,31.027Zm17.1-9.267c.028.423-.7.451-1.127.479-.2,0-.394-.225-.563-.366a2.209,2.209,0,0,1,.676-.254C20.916,21.591,21.507,21.169,21.564,21.76Zm-1.887-.028c.028.028.056.056.056.085-.085-.028-.141-.056-.225-.085C19.564,21.732,19.648,21.7,19.677,21.732Zm-12.731.2c-.028-.338.31-.254.479-.338a2.5,2.5,0,0,1,.592-.169c.31-.056.676-.085,1.014-.169.2-.056.31,0,.423.2.085.141-.2.563-.394.676a2.112,2.112,0,0,1-1.606-.056C7.283,22.014,6.945,21.986,6.945,21.929ZM18.24,27.253a.421.421,0,0,1,.2-.085c.028,0,.113.113.113.113C18.381,27.422,18.268,27.422,18.24,27.253Zm7.605,2.028c-.282.113-.845-.169-.817-.394.028-.141.169-.338.282-.338a1.639,1.639,0,0,1,.732.085C26.183,28.661,26.042,29.2,25.845,29.281Zm.366,2.845c.028.028.056.028.056.056-.085,0-.141-.028-.225-.028C26.1,32.154,26.183,32.1,26.211,32.126Zm.282.169c.394-.056.789-.282,1.1.2A.773.773,0,0,1,26.493,32.295Zm1.239.423c-.056-.056-.056-.113-.085-.2.2-.056.31.028.282.2C27.929,32.717,27.76,32.745,27.732,32.717Zm3.436-.9.056-.141.085.141Zm5.07-5.971c-.817,1.042-.873,1.042-2.169.62-.282.056-.592.225-.817.169-2.141-.789-4.422-.085-6.563-.789a.781.781,0,0,0-.789.113,3.585,3.585,0,0,1-3.239.366,2.95,2.95,0,0,0-2.394.169c-.141.085-.507,0-.507-.056-.141-1.437-1.577-.451-2.141-1.155a.571.571,0,0,0-.507-.085c-.873,1.268-1.8.845-2.789.2-1.465.2-2.958.366-4.422.592a2.969,2.969,0,0,1-1.915-.141.3.3,0,0,1-.113-.169c.028-.085.113-.2.169-.2,2.479-.338,4.957-.761,7.464-.958a40.947,40.947,0,0,1,6.7-.254c1.042.085,2.253.056,2.873-.761.648-.845.789-.592,1.268.028a1.98,1.98,0,0,0,2.253.535.589.589,0,0,0,.169.113,10.126,10.126,0,0,0,3.324.028c1.014,0,1.972.535,3.042.2,1.07-.366,1.746.225,2.141,1.183A1.332,1.332,0,0,1,36.239,25.845Zm8.675-2.929c.028,0,.056.085.085.141a.421.421,0,0,1-.2.085c-.028,0-.056-.085-.085-.141A.6.6,0,0,1,44.914,22.915Zm-.958-2.789c.423-.2.676.056.873.394.028.056-.141.254-.225.394-.085,0-.2.056-.254,0-.225-.113-.451-.254-.676-.394C43.787,20.38,43.844,20.183,43.956,20.127Zm-5.267,4.028a.219.219,0,0,1,.225-.056,2.349,2.349,0,0,1,.338.225c-.113.028-.253.085-.366.113C38.633,24.464,38.548,24.352,38.689,24.155Zm1.1,1.972c-.225.028-.592-.028-.676-.2-.169-.282.141-.423.366-.507a5.355,5.355,0,0,1,.7-.085C40.154,25.676,40.238,26.07,39.788,26.126Zm.394-.845a1.814,1.814,0,0,1-.789-.93,3.078,3.078,0,0,1,.479-.141c.732-.113,1.127.028,1.1.423C40.914,25.084,40.548,25.2,40.182,25.281Zm-.225-1.944a.992.992,0,0,1-.479-.592.981.981,0,0,1,.338-.676.6.6,0,0,1,.507-.113c.282.028.62.113.676-.225.028-.169-.31-.366-.479-.592-.113-.141-.732.085-.366-.394.169-.225.394-.789.845-.507.507.31,1.324.366,1.268,1.268-.028.62.592.9.761,1.437a.939.939,0,0,1-.282.958C41.9,23.2,40.8,23.732,39.957,23.338ZM42.21,25.76c-.056.056-.169.028-.253.028-.028-.056-.113-.141-.085-.169.056-.056.113-.141.2-.141C42.323,25.478,42.379,25.591,42.21,25.76Zm0-1.211c.028-.113.028-.282.113-.338a1.067,1.067,0,0,1,.366-.169c.056.141.084.282.141.423a2.208,2.208,0,0,1-.394.141C42.379,24.633,42.295,24.577,42.21,24.549Zm.873,10.422c0-.056.028-.113.028-.169C43.252,34.858,43.224,34.886,43.083,34.971Zm.169-9.239a5.453,5.453,0,0,1-.31-1.211,1.2,1.2,0,0,1,1.1.563.9.9,0,0,1-.141.732A.382.382,0,0,1,43.252,25.732Zm1.606,8.112a3.235,3.235,0,0,1-.507.028c-.141-.056-.338-.2-.366-.338a.423.423,0,0,1,.423-.507,1.054,1.054,0,0,1,.507.141,1.415,1.415,0,0,1,.338.366C45.139,33.619,45,33.731,44.858,33.844Zm1.352,1.211.056-.141.084.141Zm.141-9.351c-.225.028-.338-.113-.2-.282a.851.851,0,0,1,.451-.141c.028,0,.084.113.141.141A.934.934,0,0,1,46.351,25.7Zm.056-5.155a.593.593,0,0,1,.676-.62,1.878,1.878,0,0,1,1.1.676,5.109,5.109,0,0,1-.676.676A.751.751,0,0,1,46.407,20.549Zm1.155,13.21c.085-.2.254-.2.338.028a1.486,1.486,0,0,1,.085.338c-.113-.056-.254-.085-.366-.141A.234.234,0,0,1,47.562,33.759Zm2.394-13.041c-.169-.028-.31-.056-.479-.085l.169-.338a3.376,3.376,0,0,0,.338.31c.085.056.2.141.282.2A1.27,1.27,0,0,1,49.956,20.718Zm2.648.225c-.31.225-.845-.169-.93-.648-.056-.366.253-.761.563-.732s.592.338.676.817C52.829,20.521,52.773,20.831,52.6,20.944Z" transform="translate(0.056 -0.1)"/><path d="M123.4,66.013c.028-.028.056-.028.085-.056,0-.028-.028-.028-.028-.056Z" transform="translate(-88.626 -47.366)"/><path d="M107.4,83.2l.056.056h.028Z" transform="translate(-77.133 -59.793)"/><path d="M128.3,73.817c.028-.056,0-.028,0,0Z" transform="translate(-92.146 -53.03)"/></g></svg></a>',
    autoplaySpeed: 5000,
  });

  $('#cost_slider').slick(
    {
      dots: true,
      fade: true,
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: false
    }
  );

  sections.register('cart-template', theme.Cart);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.Filters);
  sections.register('product-template', theme.Product);
  sections.register('header-section', theme.HeaderSection);
  sections.register('map', theme.Maps);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('featured-stylist-section', theme.SlideshowSection);
  sections.register('howitworks-slideshow-section', theme.SlideshowSection);
  sections.register('stylists-slideshow-section', theme.SlideshowSection);
  sections.register('meetjackie-slideshow-section', theme.SlideshowSection);
  sections.register('quotes', theme.Quotes);
});

theme.init = function() {
  theme.customerTemplates.init();

  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });

  $('.image-modal-trigger').on('click', function() {
    $('#image-modal').addClass('active');
  });
  $('#icon-close-modal').on('click', function() {
    $('#image-modal').removeClass('active');
  });

};

$(theme.init);


//Animations

$('.loader-trigger').on('click', function (e) {
  e.preventDefault();
  $('.exit-screen').addClass('active');
  var desturl = $(this).attr('href');
  var delay = 300;
  setTimeout(function () { window.location = desturl; }, delay);
  console.log(desturl);
});

var loadingTl = new TimelineMax({ paused: true });

var loadingScreen = $('.loading-screen');
var asterisk = $('#asterisk');
var jackieLogo = $('.loading-screen .icon-jackie-logo');

// Text: Personal Styling for ____ Women.
var rotatingText = ['Independent', 'Fearless', 'Strong', 'Empowered', 'Passionate', 'Compassionate', 'Ethical', 'Intentional'];
var rotatingTextContainer = $('.rotating-text');
var rotatingTextWrap = $('.rotating-text-wrap');

var indexCount = 1;
rotatingTextContainer.text(rotatingText[0]);

setInterval(() => {
  rotatingTextContainer.fadeOut(1000);

  setTimeout(() => {
    rotatingTextContainer.text(rotatingText[indexCount]);
    rotatingTextWrap.css('width', rotatingTextContainer.width());
  rotatingTextContainer.fadeIn(1000);
  }, 1000);
  if(indexCount === rotatingText.length - 1) {
    indexCount = 0;
  } else {
    indexCount++
  }
}, 4000);

// For Sustainability Page / Text: ____ Shopping
var rotatingText2 = ['Conscious', 'Ethical', 'Sustainable', 'Compassionate'];
var rotatingTextContainer2 = $('.rotating-text-2');
var rotatingTextWrap2 = $('.rotating-text-wrap-2');

var indexCount2 = 1;
rotatingTextContainer2.text(rotatingText2[0]);

setInterval(() => {
  rotatingTextContainer2.fadeOut(1000);
  setTimeout(() => {
    rotatingTextContainer2.text(rotatingText[indexCount]);
    rotatingTextWrap2.css('width', rotatingTextContainer2.width());
  rotatingTextContainer2.fadeIn(1000);
  }, 1000);
  if(indexCount2 === rotatingText.length - 1) {
    indexCount2 = 0;
  } else {
    indexCount2++
  }
}, 4000);

//Homepage loading timeline
var slideTextWrap = $('.slideshow__text-wrap');
var accountMenu = $('.account-menu');
var siteNav = $('#SiteNav');
var mainLogo = $('.site-header .icon-jackie-logo');
var heroBannerText = $('.hero-banner-text-box');
var overlayed_box = $('#overlayed_box');
var patterned_img = $('.plank-pattern-img');
var stylists_banner = $('.stylists-banner');
var howItWorksPage = $('.page-howitworks');
var overlayedPinkBox = $('#overlayed_pink_box');

var stylistItemOne = $('.stylist__item')[0];
var stylistItemTwo = $('.stylist__item')[1];

var meetJackiePage = $('.page-meetjackie');

//Employee pages
var janaePage = $('.page-janae');
var amberPage = $('.page-amber');

loadingTl
  .to(asterisk, 0.5, { ease: Power0.easeNone, autoAlpha: 1 })
  .to(loadingScreen, 0.5, { ease: Power4.easeIn, x: '100%' }, '-=0.2');

if (slideTextWrap.length) {
  loadingTl
    // .from(mainLogo,0.6, { ease: Power2.easeOut, autoAlpha:0 }, '-=0.5')
    .from(slideTextWrap,0.6, { ease: Power2.easeOut, opacity:0, y: 100 }, '-=0.5');
    // .from(siteNav,0.6, { ease: Power2.easeOut, autoAlpha:0 }, '-=0.5')
    // .from(accountMenu, 0.6, { ease: Power2.easeOut, autoAlpha:0 }, '-=0.5');
} else if (howItWorksPage.length) {
  loadingTl
    // .from(mainLogo, 0.6, { ease: Power2.easeOut, autoAlpha: 0 }, '-=0.5')
    .from(heroBannerText, 0.6, { ease: Power2.easeOut, opacity: 0, y: 100 }, '-=0.5')
    // .from(siteNav, 0.6, { ease: Power2.easeOut, autoAlpha: 0 }, '-=0.5')
    .from(overlayed_box, 0.6, { autoAlpha: 0 }, '-=0.5')
    .from(patterned_img, 0.6, { autoAlpha: 0 }, '-=0.5')
    .from(stylists_banner, 0.6, { autoAlpha: 0 }, '-=0.5');
} else if (meetJackiePage.length) {
  loadingTl
    // .from(mainLogo, 0.6, { ease: Power2.easeOut, autoAlpha: 0 }, '-=0.5')
    .from(heroBannerText, 0.6, { ease: Power2.easeOut, opacity: 0, y: 100 }, '-=0.5');
    // .from(siteNav, 0.6, { ease: Power2.easeOut, autoAlpha: 0 }, '-=0.5')
    // .from(accountMenu, 0.6, { ease: Power2.easeOut, autoAlpha: 0 }, '-=0.5');
} else if (janaePage.length || amberPage.length) {
  var socialIcons = $('.social-icons li');
  var imagesSection = $('.images-section img');
  var imgBlock = $('.image-block img');
  loadingTl
    // .from(mainLogo, 0.6, { ease: Power2.easeOut, autoAlpha: 0 }, '-=0.5')
    .from(heroBannerText, 0.6, { ease: Power2.easeOut, opacity: 0, y: 100 }, '-=0.5');
  var loopOffset = 0.7;
  socialIcons.each(function () {
    loadingTl.from($(this), 0.3, { y: 100 }, '-=' + loopOffset);
    loopOffset -= 0.10;
  });
  imagesSection.each(function () {
    loadingTl.from($(this), 1, { autoAlpha: 0}, '-=0.75')
  });
  loadingTl.from(imgBlock, 1, { autoAlpha: 0 }, '-=0.75');
}


$(window).load(function () {
  setTimeout(function () { loadingTl.play() }, 300);
});

var animationController = new ScrollMagic.Controller({});

if ($('#shopify-section-slideshow-homepage').length) {
  var unboxing_cta_1 = $('.unboxing-cta-1');
  var unboxing_cta_2 = $('.unboxing-cta-2');
  var unboxing_content = $('.unboxing__cta-content');
  var asterisk = $('.icon-asterisk');

  var unboxingTl = new TimelineMax()
    .from(unboxing_cta_1, 1.2, {
      clip: "rect(0px 0px 300px 0px);", ease: Power3.easeOut }, '-=1')
    .from(unboxing_cta_2, 1.2, {
      clip: "rect(0px 401px 300px 401px);", ease: Power3.easeOut}, '-=1')
    .to(asterisk, 0.5, { ease: Back.easeOut.config(4), autoAlpha: 1, scale: 1.2}, '-=1')
    .from(unboxing_content, 0.5, { autoAlpha: 0 }, '-=1');

  var unboxingScene = new ScrollMagic.Scene({ triggerElement: "#unboxing_wrap", triggerHook: 0.90 })
    .setTween(unboxingTl)
    .addTo(animationController);

  var unboxingTlTwo = new TimelineMax()
    .add(TweenMax.to(unboxing_cta_1, 0.5, { y: -100 }))
    .add(TweenMax.to(unboxing_cta_2, 0.5, { y: 50 }), '-=0.5')

  var unboxingSceneTwo = new ScrollMagic.Scene({ triggerElement: "#unboxing_wrap", duration: "130%", triggerHook: 0.90 })
    .setTween(unboxingTlTwo)
    .addTo(animationController);

  var howBoxes = $('.how');
  var howItWorksTl = new TimelineMax();

  howBoxes.each(function () {
    howItWorksTl.from($(this), 0.7, {  ease: Power3.easeOut , autoAlpha: 0, y: 100 }, '-=0.5')
  });

  var howItWorksScene = new ScrollMagic.Scene({ triggerElement: "#how_it_works", triggerHook: 1 })
    .setTween(howItWorksTl)
    .addTo(animationController);

  var brands_wrap = $('.who__brands');
  var whoBG = $('.who-background');
  var whoContent = $('.who__content');
  var whoImage = $('.who__image');

  var brandsTl = new TimelineMax()
    .from(whoBG, 1, { ease: Power3.easeOut, x: '-100%' })
    .from(whoImage, 1, { ease: Power3.easeOut, autoAlpha: 0, y: 100 }, '-=1')
    .from(whoContent, 1.8, { ease: Power3.easeOut, autoAlpha: 0 }, '-=1')
    .from(brands_wrap, 1.6, { ease: Power3.easeOut, x: -100, autoAlpha: 0 }, '-=1.3');

  var brandsScene = new ScrollMagic.Scene({ triggerElement: "#who_wrap", triggerHook: 0.8 })
    .setTween(brandsTl)
    .addTo(animationController);

  var love_wrap = $('.what-youll-love');

  var ctaCards = $('.cta-card');

  var loveTL = new TimelineMax();
  ctaCards.each(function () {
    loveTL.from($(this), 1, { y: 200, autoAlpha: 0 }, '-=0.8');
  });

  var loveScene = new ScrollMagic.Scene({ triggerElement: "#what_youll_love", triggerHook: 0.8 })
    .setTween(loveTL)
    .addTo(animationController);

  // var testimonials = $('.testimonial');

  // var testimonialsTl = new TimelineMax();
  // testimonials.each(function () {
  //   testimonialsTl.from($(this), 1, { y: 200, autoAlpha: 0 }, '-=0.8');
  // });

  // var testimonialScene = new ScrollMagic.Scene({ triggerElement: "#testimonials_wrap", triggerHook: 0.8 })
  //   .setTween(testimonialsTl)
  //   .addTo(animationController);

  // var testimonial_1 = $('#testimonial_1');
  // var testimonial_2 = $('#testimonial_2');

  // var testimonialSceneOne = new ScrollMagic.Scene({
  //     triggerElement: "#testimonials_wrap",
  //     triggerHook: 0.3,
  //     duration: '150%'
  //   })
  //   .setTween(TweenMax.to(testimonial_1, 1, {'margin-top': -100}))
  //   .addTo(animationController);

  // var testimonialSceneFour = new ScrollMagic.Scene({
  //   triggerElement: "#testimonials_wrap",
  //   triggerHook: 0.3,
  //   duration: '250%'
  // })
  //   .setTween(TweenMax.to(testimonial_4, 1, { 'margin-top': -150 }))
  //   .addTo(animationController);

  // var testimonialSceneThree = new ScrollMagic.Scene({
  //   triggerElement: "#testimonials_wrap",
  //   triggerHook: 1,
  //   duration: '200%',
  //   offset: 400
  // })
  //   .setTween(TweenMax.to(testimonial_3, 1, { 'margin-top': -150 }))
  //   .addTo(animationController);

  // var testimonialSceneTwo = new ScrollMagic.Scene({
  //   triggerElement: "#testimonials_wrap",
  //   triggerHook: 1,
  //   duration: '200%',
  //   offset: 200
  // })
  //   .setTween(TweenMax.to(testimonial_2, 1, { 'margin-top': -250 }))
  //   .addTo(animationController);

  var footerContent = $('.footer-homepage__content');

  var footerScene = new ScrollMagic.Scene({
    triggerElement: '#footer_homepage',
     triggerHook: 0.3
  })
  .setTween(TweenMax.from(footerContent, 1, {
  y: 200,
  autoAlpha: 0
  }))
  .addTo(animationController);
}

if ($('#shopify-section-slideshow-hero-howitworks').length) {

  var bgStyle = $('#bg_style');
  var bgMade = $('#bg_made');
  var bgSimple = $('#bg_simple');
  var pinkCheck = $('#pink_checkbox');
  var redEye = $('#red_eye');
  var box = $('#milkblue_box');
  var imageFirst = $('#image_first');
  var textFirst = $('#text_first');
  var imageSecond = $('#image_second');
  var textSecond = $('#text_second');
  var imageThird = $('#image_third');
  var textThird = $('#text_third');

  var howItWorksBoxesTL = new TimelineMax();
  var delay = 0.2;
  
  $('.howitworksslideshow-box').each(function(e) {
    howItWorksBoxesTL.from($(this), 1, { y: 100, autoAlpha: 0 }, '-=' + delay);
    delay += 0.2;
  });
  
  var howItWorksBoxesController = new ScrollMagic.Controller();
  var howItWorksBoxesScene = new ScrollMagic.Scene({
    triggerElement: "#shopify-section-slideshow-hero-howitworks",
  })
  .addTo(howItWorksBoxesController)
  .setTween(howItWorksBoxesTL);

  var startedTl = new TimelineMax()
    .from(bgStyle, 1.3, { x: -100, autoAlpha: 0 }, '-=1')
    .from(bgMade, 1.3, { x: 100, autoAlpha: 0 }, '-=1')
    .from(bgSimple, 1.3, { x: -100, autoAlpha: 0 }, '-=1')

  var startedController = null;

  function initScene() {
      startedController = new ScrollMagic.Controller();
      var getStartedScene = new ScrollMagic.Scene({
          triggerElement: "#get_started",
          triggerHook: 0.7,
          duration: '225%',
          offset: -300
        })
        .addTo(startedController)
        .setTween(startedTl);
  }

  if ($(window).width() >= 990) {
    initScene();
  }

  $(window).resize(function () {
    if ($(window).width() <= 990) {
      if (startedController != null || startedController != undefined) {
        console.log(startedController);
        startedController = startedController.destroy(true);
        console.log(startedController);
      }
    } else {
      if (startedController == null || startedController == undefined) {
        initScene();
      }
    }
  });

  var steps = $('.step');

  var stepsTl = new TimelineMax();
  var delay = 0.2;
  
  steps.each(function(e) {
    stepsTl.from($(this), 1, { autoAlpha: 0 }, '-=' + delay);
    delay += 0.2;
  });
  
  var stepsController = new ScrollMagic.Controller();
  var stepsScene = new ScrollMagic.Scene({
    triggerElement: "#get_started",
  })
  .addTo(stepsController)
  .setTween(stepsTl);


  var whiteboard = $('#whiteboard');
  var stylist_photo = $('#stylist_photo');
  var stylist_frame = $('#stylist_frame');

  var stylistsTl = new TimelineMax()
  .from(stylist_photo, 1.3, {
    x: -50,
    y: -50
  })
  .from(stylist_frame, 1.3, {
    x: 50,
    y: 50
  }, '-=1');

  var stylistsScene = new ScrollMagic.Scene({
    triggerElement: "#stylists_slideshow",
    triggerHook: 1,
    duration: "110%"
  })
  .setTween(stylistsTl)
  .addTo(animationController);

  var whiteboardScene = new ScrollMagic.Scene({
    triggerElement: "#stylists_slideshow",
    triggerHook: 0.5
  })
  .setTween(TweenMax.from(whiteboard, 0.4, { y: 100, autoAlpha:0 }))
    .addTo(animationController);

  var left_block = $('#left_block');
  var right_block = $('#right_block');
  var left_block_content = $('.left-block--content');
  var right_block_content = $('.right-block--content');

  var styleTl = new TimelineMax()
    .to(left_block, 0.4, { width: '55%', padding: '0 90px 0 90px' })
    .to(right_block, 0.4, { width: '45%', padding: '0 90px 0 90px' })
    .to(left_block_content, 0.5, { autoAlpha: 1 }, '-=0.3')
    .to(right_block_content, 0.5, { autoAlpha: 1 }, '-=0.2');

  var styleGoalsScene = new ScrollMagic.Scene({
    triggerElement: "#style_goals_wrap",
    triggerHook: 0.8
  })
  .setTween(styleTl)
  .addTo(animationController);

  var subscriptions = $('.subscription');

  var subsTl = new TimelineMax();
  var offset = 1;
  $(subscriptions).each(function () {
    var offsetTotal = offset - 0.2;
    var offsetString = '-=' + offsetTotal;
    subsTl.from($(this), 1, {
      y: 100,
      autoAlpha: 0
    }, offsetString);
  });

  var subsScene = new ScrollMagic.Scene({
    triggerElement: "#sub_wrapper",
    triggerHook: 0.6
  })
  .setTween(subsTl)
  .addTo(animationController);
}

if ($('.page-meetjackie').length) {
  var overlayed_box = $('#overlayed_pink_box');
  var patterned_img = $('.plank-pattern-img');

  var heroTl = new TimelineMax()
    .to(overlayed_box, 1, { y: -50 })
    .to(patterned_img, 1, { y: -20 }, '-=1');

  var heroScene = new ScrollMagic.Scene({
    triggerElement: "#hero_banner",
    triggerHook: 0.2,
    duration: '100%'
  })
    .setTween(heroTl)
    .addTo(animationController);

  var container = $('.about-amber__container');
  var amberPhoto = $('.amber-photo');
  var amberContent = $('.amber-content');
  var iconOx =$('.icon-oxox');

  var storyTl = new TimelineMax()
    .from(container, 0.8, { x: 100, autoAlpha: 0 })
    .from(amberPhoto, 0.8, { x: -100, autoAlpha: 0 }, '-=0.8')
    .from(iconOx, 0.8, { autoAlpha: 0 }, '-=0.8')
    .from(amberContent, 0.8, { autoAlpha: 0 }, '-=0.1');

  var storyScene = new ScrollMagic.Scene({
    triggerElement: '#story_wrapper',
    triggerHook: 0.6,
    offset: -200,
    reverse: false
  })
    .setTween(storyTl)
    .addTo(animationController);

  var section1Title = $('.section-title');

  var story1Tl = new TimelineMax()
      .from(section1Title, 1, { y: 100, autoAlpha: 0 });

  var story1Scene = new ScrollMagic.Scene({
    triggerElement: '#story1_wrapper',
    triggerHook: 0.5
  })
    .setTween(story1Tl)
    .addTo(animationController);


  var story2Controller = null;

  var story2Bg = $('.story2-image1');
  var story2Img = $('.story2-image2');

   var story2Tl = new TimelineMax()
     .from(story2Bg, 1, {
       y: 50
     })
     .from(story2Img, 1, {
       y: -150
     }, '-=1');

  function initStory2Controller() {
    story2Controller = new ScrollMagic.Controller();

    var story2Scene = new ScrollMagic.Scene({
        triggerElement: '#story2_wrapper',
        triggerHook: 0.8,
        duration: "220%"
      })
      .setTween(story2Tl)
      .addTo(story2Controller);
  }

   if ($(window).width() >= 990) {
     initStory2Controller();
   }

   $(window).resize(function () {
     if ($(window).width() <= 990) {
       if (story2Controller != null || story2Controller != undefined) {
         story2Controller = story2Controller.destroy(true);
       }
     } else {
       if (story2Controller == null || story2Controller == undefined) {
         initStory2Controller();
       }
     }
   });

  // var section2Title = $('.section-title-two');

  // var story2Scene2 = new ScrollMagic.Scene({
  //   triggerElement: '#story2_wrapper',
  //   triggerHook: 0.4
  // })
  //   .setTween(TweenMax.from(section2Title, 1, { y: 100, autoAlpha: 0 }))
  //   .addTo(animationController);

  var story3Image = $('.story3-image2');
  var rightBlock = $('.right-block');
  var iconxx = $('.icon-xx');

  var story3Tl = new TimelineMax()
    .from(story3Image, 1, { y: -100 })
    .from(rightBlock, 1, { y: 100 }, '-=1')
    .from(iconxx, 1, { x: 100 }, '-=1');

  var story3Scene = new ScrollMagic.Scene({
    triggerElement: '#story3_wrapper',
    triggerHook: 0.8,
    duration: '150%'
  })
    .setTween(story3Tl)
    .addTo(animationController);

  var pinkFrame = $('.meetjackie-pink-frame');

  var meetJackieSlideScene = new ScrollMagic.Scene({
    triggerElement: '#slideshow_wrap',
    triggerHook: 0.6,
  })
    .setTween(TweenMax.to(pinkFrame, 0.4, { width: '500px' }))
    .addTo(animationController);
}

if ($('.page-janae').length || $('.page-amber').length) {
  var employeeSign = $('.employee-sign');
  var quoteText = $('.quote-text');
  var quoteTextSpan = $('.quote-text span');
  var signTl = new TimelineMax()
    .from(quoteText, 0.5, { width: 0, padding: 0 })
    .from(quoteTextSpan, 1, { autoAlpha: 0 })
    .to(employeeSign, 0.5, {autoAlpha: 1}, '-=0.5');
  var quoteSceneOne = new ScrollMagic.Scene({
    triggerElement: '#quote_text',
    triggerHook: 0.5,
  })
  .setTween(signTl)
  .addTo(animationController);

  var vertical_line_1 = $('#vertical_line_1');
  var quoteSceneTwo = new ScrollMagic.Scene({
    triggerElement: '#vertical_line_1',
    triggerHook: 0.7,
    offset: 200,
    duration: '100%'
  })
    .setTween(TweenMax.to(vertical_line_1, 0.5, { y:100 }, '-=1'))
    .addTo(animationController);

  var vertical_line_2 = $('#vertical_line_2');
  var quoteSceneTwo = new ScrollMagic.Scene({
    triggerElement: '#vertical_line_2',
    triggerHook: 0.7,
    offset: 200,
    duration: '100%'
  })
    .setTween(TweenMax.to(vertical_line_2, 0.5, { y: -100 }, '-=1'))
    .addTo(animationController);

  var employeeSign = $('.employee-sign');
  var quoteSceneTwo = new ScrollMagic.Scene({
    triggerElement: '#quote_text',
    triggerHook: 0.4
  })
  .setTween(TweenMax.to(employeeSign, 0.5, { autoAlpha: 1}, '-=1'))
  .addTo(animationController);

  var customer_question = $('.customer-question-wrap');

  var questionTl = new TimelineMax()
    .from(customer_question, 0.6, { y: 100, autoAlpha: 0 });

  var questionScene = new ScrollMagic.Scene({
    triggerElement: '#question_wrap',
    triggerHook: 0.8,
  })
    .setTween(questionTl)
    .addTo(animationController);

  var leftBlock = $('.bottom-images-section .left-block');
  var rightBlock = $('.bottom-images-section .right-block');
  var xoIcon = $('#big_oxox');

  var bottomImagesTl = new TimelineMax()
    .to(leftBlock, 0.4, { width: '50%' })
    .to(rightBlock, 0.4, { width: '50%' })
    .to(xoIcon, 1, { autoAlpha: 1 }, '-=0.3');

    var bottomImagesScene = new ScrollMagic.Scene({
      triggerElement: '#bottom_images_section',
      triggerHook: 0.8
    })
    .setTween(bottomImagesTl)
    .addTo(animationController);
}

if(!Cookies.get('quiz')){
  $('#AddToCart-product-template').on('click', function(e){
    $('#product_popup').addClass('open');
    e.preventDefault();
  });
}

$('#add_to_cart').on('click', function(){
  $('#add_to_cart_form').submit();
});

$('#talk_to_stylist').on('click', function(){
  $('#product_popup').removeClass('open');
  window.Intercom('show');
});

$('#close').on('click', function(){
  $('#product_popup').removeClass('open');
});

$('#talk-to-stylist').on('click', function(){
  window.Intercom('show');
});